/* One block, two features that share a body-builder: the prefilled support email
   and the size recommender. They are together on purpose -- the recommender's
   own "email us" link has to carry the numbers the customer just typed, and
   duplicating the composition would let the two versions drift.

   UNGATED, unlike the toggle fallback below: this must run on every browser.

   Product identity comes from the page's own Open Graph tags rather than theme
   markup, because the chart renders on a standalone page, inside the product
   size modal and potentially in a grid quick view, and only og:* is present and
   correct in all three. On a page that is not a product it falls back to the
   chart's own title.

   Only mailto: links are touched -- the dealer-locator link in the same list is
   not a mailto and must be left alone. */
(function () {
  var MAIL = 'info@levelsix.com';

  /* A chart ROW label and an INPUT label are not the same job.
     "Cockpit length (min to max)" is right above a column showing a range;
     over an empty box it is asking the customer for two numbers. Alex,
     2026-08-04: the find-your-size fields, and the email they generate, should
     name what the person is measuring.

     Corpus-wide there are exactly eight bracketed labels:
       Arm length (max)              Cockpit length (max)
       Cockpit length (min to max)   Cockpit width (max)
       Cockpit width (min to max)    Palm width (around)
       Tunnel (waist opening)        Waist (adjustability range)

     Dropping the bracket handles seven. The eighth is a rename, not a trim --
     "Tunnel" is the garment part, and the customer is measuring their waist --
     so it is DECLARED here rather than inferred from the bracket text. Both
     tunnel forms converge on "Waist", which is what they always meant.

     Applied at RUNTIME, so the chart TABLES keep their own headings (a column
     really does show min to max) and no chart body has to be rewritten. */
  var LABEL_RENAME = { 'tunnel': 'Waist' };

  function cleanLabel(s) {
    var out = String(s == null ? '' : s).replace(/\s*\([^)]*\)\s*$/, '').trim();
    var key = out.toLowerCase();
    return Object.prototype.hasOwnProperty.call(LABEL_RENAME, key)
      ? LABEL_RENAME[key] : out;
  }

  function meta(prop) {
    var el = document.querySelector('meta[property="' + prop + '"]');
    return el ? (el.getAttribute('content') || '') : '';
  }
  function num(v) { v = parseFloat(v); return isFinite(v) ? v : null; }
  function subjectFor(root) {
    var isProduct = meta('og:type') === 'product';
    var name = isProduct ? meta('og:title') : '';
    var titleEl = root ? root.querySelector('.ls-title') : null;
    return name || (titleEl && titleEl.textContent) || 'this product';
  }
  function pageUrl() {
    return meta('og:type') === 'product' ? (meta('og:url') || location.href)
                                         : location.href;
  }
  /* Ask whether ANY inches radio in this block is checked -- never "find the
     first one, then ask if it is checked".

     There are TWO unit toggles in a chart (the table's, and the one above the
     size recommender) and they deliberately share a radio NAME, so the browser
     treats all four inputs as ONE group: checking inches on the second toggle
     unchecks the first toggle's radio. `querySelector('.ls-r-in')` returns the
     FIRST inches radio, which is exactly the one that did NOT get checked, so
     the old form reported `cm` while the customer was reading inches -- and the
     prefilled support email then labelled their inch measurements "cm". Alex
     caught it live 2026-07-31 on jasper-splash-top.

     Putting `:checked` inside the selector makes this immune to how many copies
     exist, which is the same property the stylesheet already relies on. It has
     to be: the product size modal CLONES the whole block at runtime, so there
     can be four toggles on the page, not two. */
  function unitOf(root) {
    return root && root.querySelector('.ls-r-in:checked') ? 'inches' : 'cm';
  }
  function fieldList(root, attr) {
    var raw = (root && root.getAttribute(attr)) || '';
    return raw ? raw.split('|') : [];
  }

  /* Named blanks, or the customer's own numbers where we have them. Listing the
     fields stops somebody sending three of eight measurements and leaving
     customer service to chase the rest; filling them in means the recommender's
     link arrives already answered. */
  function blanks(list, values, unit) {
    var out = '', i, v;
    for (i = 0; i < list.length; i++) {
      v = values && (list[i] in values) ? values[list[i]] : null;
      out += cleanLabel(list[i]) + ': ' + (v === null ? '' : v + ' ' + unit) + '\n';
    }
    return out + '\n';
  }

  /* Wording is Alex's, 2026-07-30: the customer's own opening sentence rather
     than a labelled form, because a support inbox reads better that way. */
  function compose(root, values, suggestion, caveats, down) {
    var what = subjectFor(root);
    var unit = unitOf(root);
    var mine = fieldList(root, 'data-ls-measure');
    var theirs = fieldList(root, 'data-ls-boat');
    var body = 'Hey, I am looking for sizing help with the ' + what
      + ', found at this url ' + pageUrl() + '.\n\n';
    if (suggestion) {
      body += 'The size chart suggested ' + suggestion + '.\n\n';
    }
    /* The caveat is the REASON they are writing, so it has to travel. Without
       it a caveated answer arrives looking like a routine confirmation and
       customer service has no idea the customer is asking about a smaller size.
       Rewritten into the customer's own voice, from the same strings the page
       shows, so the two can never disagree. */
    if (caveats && caveats.length) {
      /* Every caveat is written as "Your <thing> ...", so one substitution puts
         the whole set in the first person. Deliberately not a second set of
         strings: two copies of this wording WILL drift, and the page and the
         inbox disagreeing about why someone wrote in is worse than a slightly
         mechanical sentence. */
      body += caveats.join(' ').split('Your ').join('My ') + '\n\n';
      if (down) {
        body += 'Could you tell me whether ' + down + ' would work for me?\n\n';
      }
    }
    body += 'My measurements are:\n'
      + (mine.length ? blanks(mine, values, unit) : '\n\n');
    /* Boat rows are listed separately: a cockpit is not something the customer
       measures on themselves, and mixing the two under one prompt is how people
       end up measuring the wrong thing. */
    if (theirs.length) {
      body += 'My boat is:\n' + blanks(theirs, values, unit);
    }
    /* Waterproof outer layers. What goes UNDERNEATH changes the size needed, and
       a customer's size in a brand they already own is often the fastest way to
       place them. */
    if (root && root.getAttribute('data-ls-drygear')) {
      body += 'Layers I normally wear under this would be '
        + '(are your layers thicker or more minimalist?):\n\n\n'
        + 'My size in my favourite outerwear brand is '
        + '(please tell us the brand and both your pant size and rain jacket '
        + 'size):\n\n\n';
    }
    body += 'I want to use it for:\n\n\n' + 'Thanks so much!\n';
    return 'mailto:' + MAIL + '?subject=' + encodeURIComponent('Sizing help: ' + what)
      + '&body=' + encodeURIComponent(body);
  }

  function prefill() {
    var links = document.querySelectorAll('.ls-sizechart a.ls-mail[href^="mailto:"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute('data-ls-prefilled')) continue;
      var root = a.closest ? a.closest('.ls-sizechart') : null;
      a.setAttribute('href', compose(root, null, null));
      a.setAttribute('data-ls-prefilled', '1');
    }
  }

  /* ---- SIZE RECOMMENDER ------------------------------------------------
     Suggests a size from the customer's own measurements, using the numbers
     already printed in the chart above it. Deliberate limits, because a
     confident wrong size costs a return:
     - every box must be filled;
     - height, inseam, waist and chest decide the answer, everything else can
       only add a note;
     - straddling two sizes is reported as straddling, not rounded;
     - the answer is always framed as an estimate, with a way to reach a human. */

  function bestIndex(ranges, value) {
    var hits = [], nearest = [], bestDist = Infinity, i, r, d;
    for (i = 0; i < ranges.length; i++) {
      r = ranges[i];
      if (!r) continue;
      if (value >= r[0] && value <= r[1]) { hits.push(i); continue; }
      d = value < r[0] ? r[0] - value : value - r[1];
      if (d < bestDist - 1e-9) { bestDist = d; nearest = [i]; }
      else if (Math.abs(d - bestDist) < 1e-9) { nearest.push(i); }
    }
    return hits.length ? hits : nearest;
  }

  /* ONE place resolves which column a field is read from. Duplicating this
     ternary is how the 2026-08-03 unit bug happened in a different function. */
  function bandsFor(f, unit) {
    return (unit === 'in' && f['in'] && f['in'].length) ? f['in'] : f.cm;
  }

  /* AN IDEAL-MEASUREMENT LADDER, and the reason it needs deriving at all.
     Alex, 2026-08-12: where a chart prints ONE figure per size rather than a
     band, that figure is the IDEAL measurement for the garment -- above it fits
     tighter, below it fits looser.

     Read that way the picker was already almost right: bestIndex() falls back to
     the nearest band when a value sits inside none, and nearest-neighbour over a
     set of ideals IS ideal matching. The only thing that failed was the exact
     TIE, and because the printed figures are evenly spaced the midpoints land on
     whole numbers a customer can actually select -- which is why the failures
     looked systematic rather than rare. Measured across all 80 body-measurement
     point fields on CA: every failing value is exactly a midpoint, no exceptions.

     So each size gets the interval between its neighbouring midpoints. 188
     stuck values become answerable and 1,005 working answers are UNCHANGED --
     provably, because the midpoint interval around a point is by definition the
     set of values nearer to it than to any other point.

     Deriving it HERE rather than in the payload is what keeps this to three
     asset pushes: the printed figures are already in the page, the chart bodies
     stay byte-identical, and one push reverses it. */
  function allIdealPoints(bands) {
    var i;
    if (!bands || bands.length < 2) return false;
    for (i = 0; i < bands.length; i++) {
      /* A null band is a printed GAP -- footwear has no USA 9 -- and a ladder
         with a hole in it has no honest midpoint across the hole. */
      if (!bands[i] || bands[i][0] !== bands[i][1]) return false;
      if (i && bands[i][0] <= bands[i - 1][0]) return false;   /* strictly rising */
    }
    return true;
  }

  function idealBands(f, unit) {
    /* Boat rows are excluded: a cockpit rim is a genuine LIMIT, not an ideal.
       Mariner and Nylon print "Cockpit length (max)" as single figures, and
       midpoint logic there would tell a 100 cm cockpit that the 96 cm size
       fits. Declared via `b`, not guessed from the "(max)" in the label. */
    if (f.b) return null;
    /* Points in ONE unit and ranges in the other means the single figure is a
       transcription of the range, not an ideal. Collider Cap and Neoprene
       Headwear print a centimetre band against one inch number, and both
       captions already say that number is the TOP of the band. Excluding on
       disagreement between the two units catches them without naming them. */
    if (!allIdealPoints(f.cm)) return null;
    if (f['in'] && f['in'].length && !allIdealPoints(f['in'])) return null;
    var pts = bandsFor(f, unit), out = [], i, n = pts.length;
    if (!allIdealPoints(pts)) return null;
    for (i = 0; i < n; i++) {
      out.push([
        i === 0 ? 0 : (pts[i - 1][0] + pts[i][0]) / 2,
        /* The top of the ladder is NOT widened. Above the largest printed
           figure the existing "may fit tight" fallback still runs, which is the
           honest answer and not a refusal. */
        i === n - 1 ? pts[i][0] : (pts[i][0] + pts[i + 1][0]) / 2
      ]);
    }
    return out;
  }

  /* A MAXIMUM IS NOT A NEAREST NEIGHBOUR, and reading one as the other sells a
     skirt that does not go on the boat.

     Alex, 2026-08-18: "for the boats, that single number is a max so treat it as
     a range. XS for instance is 0-86 cm, S is 86-89 cm and M is 89-94 cm etc."

     The cockpit rows print ONE figure per size and the label says "(max)": the
     largest rim that size will fit. bestIndex() falls back to the NEAREST band
     when a value sits inside none, and nearest is symmetric while a maximum is
     not -- so a 90 cm cockpit landed on S, whose stated maximum is 89. The skirt
     does not reach. Measured across the corpus before this: nylon disagrees with
     the correct reading on 37 of 155 whole-centimetre cockpit lengths, lagoon on
     6 of 77 widths, mariner on 12 and 9.

     This is the same shape as the 2026-08-12 ideal-measurement ladder and it is
     derived in the same place and for the same reason: the printed figures are
     already in the page, the chart bodies stay byte-identical, no page needs
     re-pushing, and one asset push reverses it. It is a DIFFERENT rule, though,
     and the two must not be confused -- an ideal is the middle of its size and a
     maximum is the top of it, so one derives midpoints and the other derives
     the interval up from the size below.

     Boat rows only. `b` is declared in the payload, not guessed from the "(max)"
     in the label, so a body row that happens to print rising single figures
     cannot be swept in. The neoprene skirts and neo-tour already publish real
     ranges and are untouched by this. */
  function isMaxLadder(bands) {
    var i;
    if (!bands || bands.length < 2) return false;
    for (i = 0; i < bands.length; i++) {
      if (!bands[i] || bands[i][0] !== bands[i][1]) return false;
      /* NON-decreasing, not strictly rising. Nylon's cockpit width plateaus at
         57 across XL, 2XL and 3XL and at 61 across 4XL and 5XL. The plateau is
         on the artwork and means width does not separate those sizes; length
         does. A plateau yields a zero-width band, which is correct: it says
         nothing new, and the intersection with the length row is what places
         the customer. */
      if (i && bands[i][0] < bands[i - 1][0]) return false;
    }
    return true;
  }

  function maxBands(f, unit) {
    if (!f.b) return null;
    /* Both units must be ladders, for the same reason idealBands checks both:
       points in one unit and ranges in the other means the single figure is a
       transcription of the range rather than a maximum in its own right. */
    if (!isMaxLadder(f.cm)) return null;
    if (f['in'] && f['in'].length && !isMaxLadder(f['in'])) return null;
    var pts = bandsFor(f, unit), out = [], i;
    if (!isMaxLadder(pts)) return null;
    for (i = 0; i < pts.length; i++) {
      /* From the size below's maximum up to this size's own. The smallest starts
         at zero: there is no cockpit too small for the smallest deck, it simply
         goes on loose, and refusing to place a small boat would be a refusal
         with no size behind it. */
      out.push([i === 0 ? 0 : pts[i - 1][0], pts[i][0]]);
    }
    return out;
  }

  /* Every read inside solve() goes through here, so the caveats compare against
     the same bands the answer was chosen from. Reading raw points for the
     caveats would report "above the range for 5T, our largest size" to anyone a
     centimetre over their ideal. */
  function solveBands(f, unit) {
    return idealBands(f, unit) || maxBands(f, unit) || bandsFor(f, unit);
  }

  /* May this measurement rule a size OUT, or may it only annotate one?
     - secondary rows (arm, neck, hands, feet) never exclude. Alex, 2026-08-06:
       the arm "should provide a caveat that the arms might be short for them".
     - `nc` is the per-row declaration described in fit_payload(): Height caps on
       full-body garments and not on pants, and the two are indistinguishable
       from the payload alone.
     - a boat row on a MAX LADDER caps, and this reversed on 2026-08-18.

     The old rule read "boat rows are not measured on a body at all, so the whole
     hard/soft asymmetry does not apply". That was right while the cockpit rows
     were single points matched by nearest neighbour, because "over the top of
     this size" had no meaning: there was no top, only a figure to be near.

     Once those figures are read as maxima there is a top, and exceeding it is
     the hardest constraint on the chart. A cockpit rim is rigid and the deck
     either reaches around it or it does not, which is a stronger exclusion than
     any body measurement -- a chest over a size's maximum is merely tight.

     This is what makes the two cockpit rows compose. Length and width often
     disagree, and the empty-intersection fallback is a UNION whose floor is the
     SMALLER index: without capping, a boat one centimetre too long for M was
     answered M, whose printed maximum it had just exceeded. With capping, the
     floor search finds the smallest size no cockpit dimension exceeds, which is
     exactly "the smallest deck that goes on this boat". */
  function capsSize(f, unit) {
    if (f.b) { return !!maxBands(f, unit); }
    return !!f.d && !f.nc;
  }

  /* Length rows run short or long; girth rows fit snug or loose. Deciding from
     the label keeps this to one rule with no list to maintain, and the worst
     case is a slightly odd sentence rather than a wrong size. */
  function isLength(label) {
    return /length|inseam|height/i.test(label);
  }

  /* "chest", "chest and waist", "chest, waist and inseam". */
  function joinList(list) {
    if (list.length < 2) { return list[0] || ''; }
    return list.slice(0, list.length - 1).join(', ') + ' and ' + list[list.length - 1];
  }

  function solve(table, values, unit) {
    var dominant = [], all = [], notes = [], i, f, idx, halfway = null, ties = [];
    for (i = 0; i < table.f.length; i++) {
      f = table.f[i];
      if (!(f.l in values)) continue;
      idx = bestIndex(solveBands(f, unit), values[f.l]);
      if (!idx.length) continue;
      /* EXACTLY ON A MIDPOINT. The neighbouring derived bands share that
         endpoint, so both contain it and bestIndex returns two. Both sizes are
         equally far from ideal -- one slightly tight, one slightly loose -- so
         this is a choice to explain rather than an uncertainty to report.
         Take the LARGER: under is looser, over is tighter, and loose is the
         error a customer can live with. Same asymmetry as the hard floor.

         COLLECTED here, CHOSEN below, and the split is the whole point. Which
         rows decide the answer is not known until the loop ends, because it
         depends on whether ANY row is dominant. Recording the note here made
         every row eligible to announce a size decision, including the ones
         declared unable to make one: `kids-pfd-sizing` told a parent their
         child was halfway between Infant and Child while weight -- the row the
         caption says selects the size -- recommended Youth. Measured over the
         corpus before this was fixed: 89% of every emission came from a row
         that could not move the answer. Same defect family as 2026-08-06's
         chart-wide `unclear` gating a per-axis decision. */
      /* EXACTLY ON A PRINTED MAXIMUM. Consecutive derived bands share that
         figure -- XS ends at 86 and S begins at 86 -- so bestIndex returns both.
         It belongs to the SMALLER one, because the figure is that size's stated
         maximum and a maximum is inclusive: an 86 cm cockpit is precisely what
         XS is specified to fit. Taking the larger would round every published
         cockpit spec up a size, and cockpit dimensions are exactly the numbers a
         paddler copies off a manufacturer's page, so the boundary is the COMMON
         case here rather than the rare one.
         The opposite of the ideal-ladder tie below, and deliberately so: there
         both sizes are equally wrong and loose is the kinder error, here the
         smaller size is exactly right. */
      if (idx.length > 1 && maxBands(f, unit)) { idx = [idx[0]]; }
      if (idx.length > 1 && idealBands(f, unit)) {
        ties.push({ l: f.l, d: !!f.d, lo: idx[0], hi: idx[idx.length - 1] });
        idx = [idx[idx.length - 1]];
      }
      all.push({ f: f, idx: idx });
      if (f.d) dominant.push({ f: f, idx: idx });
    }
    var use = dominant.length ? dominant : all;
    if (!use.length) return null;
    /* The first tie on a row that is actually deciding. `use` is `dominant` when
       any row is dominant and `all` otherwise, so on a chart with NO dominant
       row every tie qualifies -- there, an annotating row IS the answer and the
       note is legitimate. Mirrors the `use` selection exactly rather than
       testing `f.d` alone, which would silence the note on those charts. */
    for (i = 0; i < ties.length && !halfway; i++) {
      if (!dominant.length || ties[i].d) { halfway = ties[i]; }
    }
    /* INTERSECT the deciding measurements -- do NOT union them.
       Taking lo = min and hi = max ACROSS the fields is a union, so whichever
       field spans the most sizes decides the answer in BOTH directions, and a
       field that agrees precisely cannot narrow it. An "adjustability range"
       row describes what a garment cinches to rather than what a body measures,
       so it routinely covers three sizes at a single value -- and under a union
       it always won. Alex, 2026-08-04, from a live page: Chest 39 / Waist 34 /
       Arm 32 answered "S to L" where the chest alone says M and the arm is over
       S's maximum outright.
       So: keep only the sizes EVERY deciding measurement allows. Fall back to
       the union only when they share none, which is the real "between sizes" --
       the customer's measurements genuinely disagree and saying so is honest.
       Measured over the whole corpus before it was written here: 636 solves,
       90 narrowed, 0 widened, 0 containment breaks. */
    var inter = use[0].idx.slice(), keep, k;
    for (i = 1; i < use.length; i++) {
      keep = [];
      for (k = 0; k < inter.length; k++) {
        if (use[i].idx.indexOf(inter[k]) !== -1) { keep.push(inter[k]); }
      }
      inter = keep;
    }
    var lo = Infinity, hi = -Infinity, conflict = false, tight = false;
    /* Was the floor set by a cockpit MAXIMUM? Declared up here because two
       branches far apart both need it: the layering advisory just below, and the
       "shall we check a smaller size" offer at the end. */
    var boatFloor = false;
    if (inter.length) {
      for (i = 0; i < inter.length; i++) {
        lo = Math.min(lo, inter[i]);
        hi = Math.max(hi, inter[i]);
      }
    } else {
      /* CONFLICT -- no size satisfies every deciding measurement.
         Measurements do not exclude symmetrically, and the union treated them as
         if they did. A value OVER a size's maximum makes that size physically
         impossible: a 39 inch chest does not go into an XS whose chest tops out
         at 34. A value UNDER a size's minimum excludes nothing; the garment is
         simply bigger than the customer there, which is baggy rather than
         unwearable, and on an adjustability row it literally cinches.

         Alex, 2026-08-06, from the Solstice page: Chest 39 / Waist 26 / Arm 32
         answered "XS to M". The waist was the only thing pointing down, and it
         was pointing down for a reason that is not an exclusion.

         So the floor is hard and the ceiling is soft: recommend the SMALLEST
         size no capping measurement exceeds. Everything below it is impossible;
         everything above it is merely loose, and loose is not a recommendation.

         Measured over the corpus before this was written: 2,375 generated
         conflicts, floor raised 2,349, lowered 0, never above the old range's
         top, never onto a size a capping measurement is over, and 640
         skirt/boat conflicts unmoved. */
      var caps = [], band, blocked;
      for (i = 0; i < use.length; i++) {
        if (capsSize(use[i].f, unit)) { caps.push(use[i]); }
      }
      if (!caps.length) {
        /* Without a capping measurement, "the smallest size nobody is too big
           for" is vacuously the smallest size -- it would recommend the tiniest
           cockpit on every skirt. Boat tables carry no dominant row, and neither
           does a skirt tunnel. Both keep the union they already had. */
        for (i = 0; i < use.length; i++) {
          lo = Math.min(lo, Math.min.apply(null, use[i].idx));
          hi = Math.max(hi, Math.max.apply(null, use[i].idx));
        }
      } else {
        conflict = true;
        for (i = 0; i < caps.length; i++) {
          if (caps[i].f.b) { boatFloor = true; break; }
        }
        lo = -1;
        for (i = 0; i < table.s.length && lo < 0; i++) {
          blocked = false;
          for (k = 0; k < caps.length; k++) {
            band = solveBands(caps[k].f, unit)[i];
            if (band && values[caps[k].f.l] > band[1]) { blocked = true; break; }
          }
          if (!blocked) { lo = i; }
        }
        /* Over the top of every size: recommend the largest and say it is tight,
           rather than refusing to answer. */
        if (lo < 0) { lo = table.s.length - 1; tight = true; }
        hi = lo;
      }
    }
    /* CAVEATS. Secondary measurements never move the answer -- they explain it.
       Directional, because "points at XL" told the customer nothing actionable:
       being OVER a size means it runs short or fits snug, being UNDER means it
       runs long or fits loose, and those are different problems. */
    var sz = table.s[lo], top = table.s[hi], lbl, a, bnd;
    /* Grouped, not one sentence per field. Two fields in the same state produced
       the SAME sentence twice with only the body part swapped, which reads like
       a bug even though it is not. */
    var looseGirth = [], looseLength = [], over = [], short_ = [], snug = [];
    for (i = 0; i < all.length; i++) {
      f = all[i].f;
      if (f.b) continue;                       /* boat rows say nothing about fit */
      lbl = cleanLabel(f.l).toLowerCase();
      if (capsSize(f, unit)) {
        /* UNDER the recommendation: why it is bigger than part of them. Only
           meaningful on a conflict, where the floor was set by something else. */
        bnd = solveBands(f, unit)[lo];
        if (conflict && bnd && values[f.l] < bnd[0]) {
          (isLength(lbl) ? looseLength : looseGirth).push(lbl);
        }
        /* OVER the recommendation. This can only happen on the LARGEST size --
           anywhere else the floor would have moved up -- so it means the
           customer is off the end of the chart.

           Checked here rather than only on the conflict path, because
           bestIndex() falls back to the NEAREST band when a value sits inside
           none. A customer over every size on every measurement therefore has
           all their fields agree on the largest one, the intersection succeeds,
           and the conflict branch never runs. They were being handed the top
           size with no warning at all. Same physical fact either way. */
        bnd = solveBands(f, unit)[hi];
        if (bnd && values[f.l] > bnd[1]) { over.push(lbl); }
        continue;
      }
      /* A BLOCKING row is not a fit caveat and must not borrow this sentence.
         "Your waist is above L's range, so it may fit snug" is the wrong claim
         about a fixed opening: a tunnel the customer is over does not fit snug,
         it does not close. The blocked branch below states that properly, in
         both directions, and this would otherwise print a second, softer
         sentence contradicting it. */
      if (f.bl) continue;
      /* A SECONDARY row the customer is over. Never moves the answer -- Alex,
         2026-08-06, the arm "should provide a caveat that the arms might be
         short for them" -- and fires on clean answers too, so someone who
         resolves cleanly to S with a long arm is still told. */
      bnd = solveBands(f, unit)[hi];
      if (!bnd || values[f.l] <= bnd[1]) continue;
      (isLength(lbl) ? short_ : snug).push(lbl);
    }
    if (looseGirth.length) {
      notes.push("Your " + joinList(looseGirth)
        + (looseGirth.length > 1 ? " measure" : " measures")
        + " smaller than " + sz + "'s range, so " + sz
        + " will fit looser through the " + joinList(looseGirth) + ".");
    }
    if (looseLength.length) {
      notes.push("Your " + joinList(looseLength)
        + (looseLength.length > 1 ? " measure" : " measures")
        + " smaller than " + sz + "'s range, so " + sz + " may run long.");
    }
    /* "OUR LARGEST SIZE HERE" HAS TO BE CHECKED, not assumed. The comment on
       the `over` branch argues this can only happen on the largest size,
       because anywhere else the floor would have moved up. That is true when
       the ladder is contiguous and false when it has a GAP: a value landing in
       a hole sits inside no band, bestIndex() falls back to the NEAREST, and
       the nearest can be the lower side. `kids-whirlpool-sizing` Chest runs
       68.5-71, 76-79, 84-86, 91.5-94, so a 73 cm chest resolves to S -- and S
       is the smallest of four while the sentence called it our largest.
       Measured: 22,431 selectable cases across 12 charts said that, and the
       ideal-measurement change did not touch any of them because they are
       range ladders, not point ladders.
       So claim it only when it is true, and otherwise say the part that is. */
    if (over.length) {
      notes.push("Your " + joinList(over) + (over.length > 1 ? " are" : " is")
        + " above the range for " + top
        + (hi === table.s.length - 1 ? ", our largest size here, so " : ", so ")
        + top + " may fit tight.");
    }
    /* "above X's range" rather than "longer than" or "larger than". Those two
       verbs each fit half the rows and break on the other half: gear bottom read
       "Your height is LONGER than S allows", which lands but is not English.
       "Above the range" is true of a length, a girth and a height alike, so one
       sentence serves every row without a per-label verb table. */
    if (short_.length) {
      notes.push("Your " + joinList(short_) + (short_.length > 1 ? " are" : " is")
        + " above " + top + "'s range, so "
        + (short_.length > 1 ? "they" : "it") + " may run short.");
    }
    if (snug.length) {
      notes.push("Your " + joinList(snug) + (snug.length > 1 ? " are" : " is")
        + " above " + top + "'s range, so "
        + (snug.length > 1 ? "they" : "it") + " may fit snug.");
    }
    /* THE SKIRT TUNNEL ADVISORY. Alex, 2026-08-06: "if someone's waist is near
       the top of the range a message could appear letting them know that they
       are near the top of the range and if they want to wear it over a few
       layers then they could size up."

       A different mechanism from everything above: it fires on a CLEAN answer,
       never moves the size and never moves the pill. The customer fits; this is
       a thing they should know before they buy.

       Matched on the RAW label, because cleanLabel() renames "Tunnel (waist
       opening)" to "Waist" -- the right thing to show a customer and the wrong
       thing to branch on. Deliberately not generalised to every measurement: a
       "near the top of your range" note on chest, waist and inseam would fire on
       roughly a quarter of all answers and become noise, and layering under a
       spray skirt is a real reason to size up in a way that it is not for a
       pair of shorts. */
    /* `!conflict` OR a cockpit floor, from 2026-08-18. The guard is there so we
       do not offer layering advice when we are not sure of the size, and on a
       max ladder a "conflict" does not mean that.

       Two cockpit rows routinely select different sizes, because each band names
       the SMALLEST deck that fits on that dimension: at exactly the 2XL maxima,
       length says 2XL and width says XL, since 57 cm is XL's stated maximum too.
       The intersection is empty and `conflict` is raised, but nothing is
       uncertain -- the floor search then returns 2XL, which satisfies both, and
       lo === hi. Left as `!conflict` alone this silently dropped "your waist is
       near the top of 2XL's range, size up if you wear layers" from the nylon
       chart, which is a sentence Alex asked for on 2026-08-06. */
    if ((!conflict || boatFloor) && lo === hi) {
      for (i = 0; i < all.length; i++) {
        f = all[i].f;
        if (f.b || !/^\s*tunnel\b/i.test(f.l)) continue;
        bnd = solveBands(f, unit)[lo];
        if (!bnd || bnd[1] <= bnd[0]) continue;
        /* INSIDE the band, not merely high. "Near the top of the range" is a
           false description of a value that is over the top of it, and until
           2026-08-18 nothing here said so: the test was a lower bound only.
           It never showed, because the only way to be over the top was to be
           over the LARGEST tunnel, and that resolved to a two-size straddle
           which this branch already skips. Declaring the cockpit rows dominant
           removed the straddle -- the boat now names exactly one size -- so the
           same customer got "your waist is near the top of 7XL, size up if you
           wear layers" printed directly above "your waist is wider than the 7XL
           tunnel opens to". Advice to size up, to someone with nothing to size
           up into, beside the sentence saying so. */
        if (values[f.l] > bnd[1]) continue;
        if (values[f.l] < bnd[0] + (bnd[1] - bnd[0]) * 0.75) continue;
        notes.push("Your " + cleanLabel(f.l).toLowerCase() + " is near the top of "
          + sz + "'s range. If you plan to wear this over layers, sizing up may "
          + "be more comfortable.");
      }
    }
    /* AN OPENING THEY DO NOT FIT THROUGH -- the first "does not fit" verdict in
       this system, and the reason it did not exist before is that nothing else
       needed one. bestIndex() never returns empty: a value above every band
       falls back to the nearest one, so being off the top of a chart has always
       resolved to the largest size with a note saying it may be tight. On a
       garment that is honest, because a tight top is still a wearable top.

       A spray skirt tunnel is not a garment measurement. It is an OPENING, and a
       waist above its maximum does not go through it in any size we make, so
       handing that customer the largest skirt is selling them a return. Alex,
       2026-08-06: when the waist is above the range, the result should be a
       message asking them to talk to customer service about sizing.

       DECLARED per row (`bl`), not matched on the label. All ten skirt charts
       carry a row whose label starts "Tunnel", and a regex put this refusal on
       every one of them -- measured, 2,478 cases across the corpus. Alex scoped
       it to the four NYLON skirts and left the five neoprene ones open, so
       inferring it would have answered his open question for him with a message
       that stops a sale. And a chest above the largest size stays a fit warning:
       a tight top is still wearable, and turning that into "contact us" would
       take the buy button off customers who can wear the garment. */
    /* BETWEEN SIZES IS AN ANSWER ON A NEOPRENE TUNNEL, not an uncertainty.
       Neoprene stretches, so the two neighbouring sizes are a real choice and
       the customer already knows which way to go once someone tells them the
       rule: next to the skin take the smaller, over layers take the larger.
       Alex, 2026-08-06, from the live Club page, where a straddling waist was
       being told to go and measure again -- a worse answer than the one we
       could have given, on a chart whose whole point is that both sizes fit
       differently rather than that one of them is wrong.

       Declared (`ly`), because every skirt chart has a tunnel row and this is
       only true of the ones made of neoprene. */
    var between = null;
    if (lo !== hi) {
      for (i = 0; i < all.length; i++) {
        if (!all[i].f.b && all[i].f.ly) {
          between = [table.s[lo], table.s[hi]];
          break;
        }
      }
    }
    /* AN OPENING THE CUSTOMER MUST FIT THROUGH, checked against the size the
       chart actually recommended rather than against the largest size on it.

       Alex, 2026-08-18: on a nylon skirt "all weight must be given to cockpit
       sizing or boat selection and people only get a warning if their waist size
       is outside the waist size range". Once the cockpit rows are dominant the
       size is decided by the BOAT, so the only tunnel that can matter is the one
       on that size. Comparing against the largest size instead -- which is what
       this did until today -- asks a question nobody is buying: a paddler whose
       cockpit needs an XS was measured against 7XL's 61-130 cm tunnel, told
       nothing, and sold a skirt whose own tunnel stops at 105.

       BOTH DIRECTIONS, and that is a departure from the hard-floor/soft-ceiling
       asymmetry used everywhere else in this function. That asymmetry is right
       for a garment, where under the minimum merely means baggy. A tunnel is a
       fixed hole with a bungee in it: over the maximum it will not go on, under
       the minimum it will not draw in far enough to seal. Neither end is a
       styling preference, so neither end is soft.

       Measured over the RECOMMENDED RANGE, not one size, so a straddled answer
       only warns when the waist sits outside every size being offered.

       WHICH BAND depends on whether the size is actually known, and getting
       that wrong states a falsehood confidently. `dominant.length` is the test:
       when a cockpit row was filled, the size came FROM the cockpit and naming
       it is the useful half of the sentence. When none was, lo/hi were derived
       from the tunnel itself, and a tunnel cannot pick a deck -- that is the
       whole defect this change exists to fix, so quoting that size back at the
       customer would reintroduce it inside the warning.

       This is not hypothetical. On the two nylon products that carry a boat
       picker, boatBuild() REMOVES the cockpit inputs by design -- the customer
       came here precisely to avoid measuring their kayak -- so solve() only ever
       sees the tunnel there. Measured before this guard: 336 product-page runs
       where the pill said S or M from the named kayak while the sentence
       underneath said 7XL.

       So with no cockpit reading, fall back to the chart-wide tunnel range and
       name no size. That warns exactly when no skirt we make fits them, which is
       both true and the plain reading of Alex's "outside the waist size range".
       The per-size check on the boat-picker path needs the size the PICKER
       resolved, which lives in pdpTail; that is a real refinement and it is
       recorded as a follow-up rather than guessed at here. */
    var blocked = null, bnd_, blo, bhi, bk, bFrom, bTo;
    var sized = dominant.length > 0;
    for (i = 0; i < all.length; i++) {
      f = all[i].f;
      if (f.b || !f.bl) continue;
      bFrom = sized ? lo : 0;
      bTo = sized ? hi : table.s.length - 1;
      blo = Infinity; bhi = -Infinity;
      for (bk = bFrom; bk <= bTo; bk++) {
        bnd_ = solveBands(f, unit)[bk];
        if (!bnd_) continue;
        if (bnd_[0] < blo) { blo = bnd_[0]; }
        if (bnd_[1] > bhi) { bhi = bnd_[1]; }
      }
      if (bhi < blo) continue;                 /* no printed band on this size */
      if (values[f.l] > bhi) {
        blocked = { l: cleanLabel(f.l).toLowerCase(), dir: 'over',
                    size: sized ? table.s[hi] : null,
                    top: sized && hi === table.s.length - 1 };
      } else if (values[f.l] < blo) {
        blocked = { l: cleanLabel(f.l).toLowerCase(), dir: 'under',
                    size: sized ? table.s[lo] : null, top: false };
      }
    }
    /* THE CAVEAT IS WHAT REACHES THE INBOX. compose() rewrites every note from
       "Your ..." into "My ..." and puts it in the prefilled email, so stating
       this as a note rather than only as a tail is what makes the customer's
       message explain itself. Alex, 2026-08-18, asked for "a corresponding email
       template that explains the situation"; the template already existed, and
       what it was missing was this sentence. */
    if (blocked) {
      /* TWO SENTENCES, and the second one is the half that makes this
         actionable. "Your waist is wider than the L tunnel" on its own reads as
         "buy a bigger one", which is the wrong instruction: the size is not the
         customer's to change, it is set by the cockpit they own. Naming why L is
         on the page is what turns the warning into something they can act on,
         and it is also what the support inbox needs, since compose() forwards
         this sentence verbatim. */
      if (!blocked.size) {
        /* No cockpit reading, so no size to name. Says only what is known, which
           is that nothing in the run fits them. */
        notes.push(blocked.dir === 'over'
          ? 'Your ' + blocked.l + ' is wider than the largest tunnel opening we '
            + 'make in this skirt.'
          : 'Your ' + blocked.l + ' is narrower than the smallest tunnel opening '
            + 'we make in this skirt.');
      } else {
        notes.push(blocked.dir === 'over'
          ? 'Your ' + blocked.l + ' is wider than the ' + blocked.size
            + ' tunnel opens to. ' + blocked.size
            + ' is the size that fits your cockpit'
            + (blocked.top ? ', and it is the largest we make.' : '.')
          : 'Your ' + blocked.l + ' is narrower than the ' + blocked.size
            + ' tunnel draws in to. ' + blocked.size
            + ' is the size that fits your cockpit.');
      }
    }
    /* EXACTLY HALFWAY BETWEEN TWO IDEALS. Say so, rather than picking silently.
       Both sizes are equally far from the ideal figure -- one runs a little
       tight, the other a little loose -- and that is a decision the customer can
       make once someone states it. Same principle as the neoprene tunnel
       advice: being between sizes is only an uncertainty when we cannot tell
       the customer what the difference means.

       Only when the tie actually decided the answer. On a multi-row chart
       another measurement usually breaks it, and explaining a tie that changed
       nothing is noise. */
    if (halfway && lo === hi && !conflict && !blocked) {
      notes.push('Your ' + cleanLabel(halfway.l).toLowerCase()
        + ' is exactly halfway between ' + table.s[halfway.lo] + ' and '
        + table.s[halfway.hi] + '. ' + table.s[halfway.lo]
        + ' fits a little snug, ' + table.s[halfway.hi] + ' a little loose.');
    }
    /* The next size down, for the "shall we check whether S works" route. Only
       meaningful on a conflict, where a smaller size was ruled out on one
       measurement but the customer may still want to ask about it. */
    /* NOT ON A BOAT CONFLICT. The offer is "a smaller size was ruled out on one
       measurement, but depending on the person it MIGHT still work, so let us
       check" -- which is honest about a body, where fit is a judgement, and
       false about a cockpit rim, where the deck either reaches around it or it
       does not. Offering to check whether M works for a boat that is longer than
       M's stated maximum invites a customer to order a skirt we already know
       will not go on. Added 2026-08-18 with the max-ladder capping: before it,
       boat rows could not raise a floor and this line was unreachable for them. */
    a = (conflict && lo > 0 && !boatFloor) ? table.s[lo - 1] : null;
    return { lo: lo, hi: hi, notes: notes, conflict: conflict, down: a,
             blocked: blocked, between: between };
  }

  /* ONE copy of the between-sizes advice, used by the chart pages, the modal and
     the product page. It said different things on different surfaces once
     already this week; a customer who reads the chart and then the product page
     should not be given two answers to one question. */
  function layerAdvice(pair, mail) {
    return 'You are between ' + pair[0] + ' and ' + pair[1] + '. Take '
      + pair[0] + ' if you will wear this next to the skin, or ' + pair[1]
      + ' if you plan to wear it over layers. If you are still unsure, email '
      + mail + '.';
  }

  /* ONE copy of the out-of-range routing, for the same reason layerAdvice has
     one: report() now needs it twice, once for the chart page and the modal and
     once after the product-page fork, and two copies of a sentence that has to
     agree is how they stop agreeing. `note` carries the caveat that says WHICH
     measurement is out and in which direction, so this sentence only has to
     handle what happens next. */
  function blockedAdvice(note, mail) {
    return note + 'That is outside the range this skirt covers, so we would '
      + 'rather size you by hand than have you order one that will not fit. '
      + 'Email ' + mail + ' and we will talk it through with you.';
  }

  function report(root) {
    var box = root.querySelector('.ls-fit');
    if (!box) return;
    var out = box.querySelector('.ls-fit-out');
    var src = box.querySelector('.ls-fit-data');
    var data;
    try { data = JSON.parse(src.textContent); }
    catch (e) { return; }
    var inputs = box.querySelectorAll('input[data-ls-f]');
    var values = {}, missing = [], i, el, v;
    for (i = 0; i < inputs.length; i++) {
      el = inputs[i];
      v = num(el.value);
      el.parentNode.classList.remove('ls-fit-missing');
      if (v === null || v <= 0) {
        missing.push(el.getAttribute('data-ls-f'));
        el.parentNode.classList.add('ls-fit-missing');
      } else { values[el.getAttribute('data-ls-f')] = v; }
    }
    if (missing.length) {
      out.className = 'ls-fit-out ls-fit-err';
      out.textContent = 'Please fill in every box so the suggestion is based on '
        + 'your whole shape. Still needed: ' + missing.join(', ') + '.';
      return;
    }
    /* Derive from unitOf(), which is the ONE place that resolves this. What
       used to be here was the two-step `querySelector('.ls-r-in')` + `.checked`
       form that the comment above unitOf() exists to forbid -- and it was the
       recommender's own bug, not the email's: it reads the FIRST inches radio,
       which is exactly the one the browser UNCHECKS when the customer uses the
       toggle sitting beside these very input boxes. It reported `cm` while the
       customer typed inches, every inch value then landed below every
       centimetre band, and bestIndex()'s nearest-match fallback returned the
       SMALLEST size with no "between sizes" note and no error. A 44 inch chest
       was told S. The stylesheet resolves the unit with `:has(...:checked)`, so
       the table flipped to inches correctly while the maths stayed in
       centimetres -- nothing on screen looked wrong. Alex, 2026-08-03. */
    var unit = unitOf(root) === 'inches' ? 'in' : 'cm';
    var lines = [], plain = [], unclear = false, picks = [], t, res, name, line;
    var caveats = [], down = null, spans = [], rows = [], blocked = null;
    var between = null;
    for (t = 0; t < data.t.length; t++) {
      res = solve(data.t[t], values, unit);
      if (!res) continue;
      name = res.lo === res.hi
        ? data.t[t].s[res.lo]
        : data.t[t].s[res.lo] + ' to ' + data.t[t].s[res.hi];
      line = data.t[t].l + ': <b>' + name + '</b>';
      plain.push(data.t[t].l + ' ' + name);
      if (res.notes.length) { caveats = caveats.concat(res.notes); }
      if (res.down && !down) { down = res.down; }
      if (res.blocked && !blocked) { blocked = res.blocked; }
      if (res.between && !between) { between = res.between; }
      /* One clean answer per TABLE, because a table is what maps to a product
         option: ace-king publishes "Tunnel size" and "Deck size", and the skirt
         carries Tunnel Size and Cockpit Size. A straddled table contributes
         nothing, so a skirt whose tunnel resolves and whose deck does not still
         preselects the tunnel. Read only on the product page (see pickPills). */
      if (res.lo === res.hi) { picks.push({ t: t, label: data.t[t].s[res.lo] }); }
      /* A SPAN means the chart genuinely cannot place this person, and after
         2026-08-06 that only happens on a table with no capping measurement --
         a skirt tunnel or a boat. A CAVEAT is different: the customer has been
         placed, and the note explains where the fit will be loose or short.
         Treating a caveat as uncertainty is what used to suppress the product
         page preselect for anyone with a slightly long arm, which is the same
         defect class as the spanned-answer suppression fixed on 2026-08-04. */
      /* WHICH tables straddled, not merely that one did. `unclear` is a single
         flag over the whole chart, and on the product page it was being used to
         suppress an answer on a DIFFERENT axis: the nylon and neo-tour skirts
         publish a tunnel row whose bands deliberately overlap, so that table can
         never resolve, and the flag it raised discarded the cockpit size the
         customer had just named their kayak to find. pdpTail() needs to ask
         whether the straddled table decides anything on THIS product, and it
         cannot ask that from a boolean. Chart pages and the modal read the
         boolean exactly as before. */
      if (res.lo !== res.hi) {
        line += ' (you are between sizes)';
        unclear = true;
        spans.push(t);
      }
      lines.push(line);
      /* The same answer, unformatted, so the product page can relabel it with
         the option name the buy box uses without re-parsing a rendered string. */
      rows.push({ t: t, n: name, l: data.t[t].l, span: res.lo !== res.hi });
    }
    /* The follow-up link carries the numbers just typed AND the suggestion, so
       an unsure customer reaches support with the whole picture already in the
       message rather than an empty template. */
    var href = compose(root, values, plain.join(', ') || null, caveats, down);
    /* The link TEXT is the address itself, never "email us" or "reach out".
       Alex, 2026-07-30: mailto: only fires if the browser has a mail handler
       registered, and a webmail user who has never registered one gets nothing
       when they click. Showing the address means a link that fails to fire costs
       them a copy and paste rather than the answer. */
    /* data-ls-prefilled is set HERE, on the link report() itself builds.
       prefill() rewrites any .ls-mail mailto that lacks the attribute, and it
       runs again on the setTimeout(init, 1200) pass -- so a customer who clicks
       Suggest inside the first 1.2s used to watch their measurements-carrying
       href be replaced by the blank template. TICKET-20260804-103027. */
    var mail = '<a class="ls-mail" data-ls-prefilled="1" href="' + href + '">'
      + MAIL + '</a>';
    /* Caveats sit between the answer and the tail: after the size, because they
       qualify it, and before the tail, because the tail is where the customer is
       handed to a person and that has to come last. */
    var note = caveats.length ? caveats.join(' ') + ' ' : '';
    var tail;
    /* THE OPENING CASE. It KEEPS the answer now and only replaces the tail.
       Until 2026-08-18 this branch emptied `lines` and `picks` and returned, so
       the whole result was the refusal.

       That was right while the tunnel could still decide the size, because then
       "no tunnel fits you" really did mean there was no size to name. It is
       wrong now. Alex, 2026-08-18, put all the weight on the cockpit rows, so
       the deck size is settled by the boat and is still completely true when the
       waist does not fit: the customer needs a 2XL deck whichever way the tunnel
       goes. Dropping it deleted the one fact the page had established, and it is
       the same shape as the out-of-stock branch fixed on 2026-08-06 -- a branch
       that RETURNS a message in place of the answer throws away whatever else
       had been resolved, and on a single-axis chart nobody notices.

       So the size lines and the preselect stand, the caveat says what is wrong,
       and the tail routes to a person. Still not product-page-only: the chart
       page and the modal give the same answer. */
    if (blocked) {
      tail = blockedAdvice(note, mail);
    } else if (!lines.length) {
      tail = 'We could not place those measurements on this chart. Email '
        + mail + ' and we will help.';
    } else if (between) {
      /* Between sizes on a stretch tunnel is a CHOICE, not a shrug. Alex,
         2026-08-06. Both sizes fit; which one is right depends on what goes
         under the skirt, and that is something only the customer knows and
         something we can tell them the rule for in one sentence. */
      tail = layerAdvice(between, mail);
    } else if (unclear) {
      /* A spread is exactly where an automated answer stops being useful, so say
         so plainly instead of dressing it up: name the tool as a work in
         progress and hand the customer to a person. */
      tail = 'This tool is a work in progress, so if the answer is unclear '
        + 'please email ' + mail + ' and our customer service team will help '
        + 'guide you to the right size.';
    } else if (down) {
      /* Placed, but a measurement is under the recommendation and a smaller size
         was ruled out on a different one. The smaller size is not a candidate on
         the numbers, which is exactly why this routes to a person rather than
         offering it: Alex, 2026-08-06, "depending on the product/the person they
         MIGHT fit in an S, so contacting customer service would be genuinely
         useful." */
      tail = note + 'If you would prefer a closer fit, email ' + mail
        + ' and we will check whether ' + down + ' will work for you.';
    } else {
      tail = note + 'This is our best estimate from the measurements you entered, '
        + 'not a guarantee of fit. If you are unsure, email ' + mail
        + ' and we will help.';
    }
    /* ---- THE PRODUCT-PAGE FORK -- the only one in this function ----------
       pdpWrap() is null on a standalone chart page, on the hidden copy that
       feeds the size modal, and on every modal clone: none of them has a
       .block-size-recommender ancestor. So on those three surfaces `tail`,
       `className` and `innerHTML` below are computed by exactly the code that
       ran before this fork existed, and the chart pages and the modal do not
       change. Alex stated that constraint three times; the byte-identity guard
       in _build/test_pdp_regression_guard.js is what proves it holds. */
    var wrap = pdpWrap(root);
    if (wrap) {
      /* pdpTail runs FIRST because it is what resolves a chart size to the
         product's own option value, and the result lines have to show the value
         that actually went onto the pill. `resolved` is an out-parameter rather
         than a return value because pdpTail returns from nine branches and
         wrapping every one of them would be a lot of noise for one field. */
      var resolved = {};
      var pdp = pdpTail(wrap, picks, data, mail, rows.length, unclear, note,
                        down, spans, between, resolved, blocked);
      lines = pdpRelabel(wrap, data, rows, resolved.chosen);
      /* Most branches return a string. Three return an object:
           `replace` -- the skirt branch, where a definite boat answer stands
              alone, because report()'s own lines would restate the tunnel in
              the chart's wording right above it;
           `extra`   -- an axis the product page resolved that report() has no
              line for, chiefly the boat's cockpit size. It joins the RESULT
              LINES rather than the tail so the blank line lands between the
              sizes and the sentence about them, not in the middle of the sizes. */
      if (pdp && typeof pdp === 'object') {
        if (pdp.replace) { lines = []; }
        if (pdp.extra && pdp.extra.length) { lines = lines.concat(pdp.extra); }
        tail = pdp.tail;
      } else {
        tail = pdp;
      }
    }
    out.className = 'ls-fit-out'
      + (unclear || blocked ? ' ls-fit-unsure' : '');
    out.innerHTML = lines.length ? lines.join('<br>') + '<br><br>' + tail : tail;
  }

  /* ---- PRODUCT-PAGE ONLY ------------------------------------------------
     Nothing below runs unless the recommender sits inside the PDP block's
     wrapper. Every function here is null-guarded and returns the tail it was
     given on any doubt, so the worst case is the customer sees exactly the
     textual answer they see today. Preselecting a pill the chart did not name
     is a wrong-size order placed on the customer's behalf, so every ambiguity
     refuses rather than resolves. */

  var DEALER_FALLBACK = '/pages/dealer-locator';

  /* A table measured on BOTH the paddler and the boat is not a crossing -- it is
     a single size scale described from both ends. The nylon skirt is the case:
     one product option, Cockpit Size, whose XS to 7XL run is the same run the
     tunnel row is indexed by, so the waist opening and the cockpit rim are two
     properties of ONE size rather than two things to choose between. Alex,
     2026-08-06: "one table instead of two."

     So optionForTable()'s axis filter applies to SINGLE-SIDED tables only. That
     filter exists to stop a waist answer setting a cockpit pill where a chart
     publishes two tables with identical size runs (splash-deck), and that hazard
     needs two tables to exist at all -- with one table there is nothing to
     confuse it with. Measured before this was written: across all 54 committed
     CA charts there were 49 paddler-only tables, 11 boat-only and ZERO mixed, so
     the relaxation reaches exactly the one table the merge creates.

     Declared ABOVE pdpWrap, like pdpRelabel, because everything from there down
     to pdpTail is held byte-identical by _build/test_pdp_regression_guard.js. */
  function tableIsMixed(table) {
    var f = (table && table.f) || [], i, sawBoat = false, sawBody = false;
    for (i = 0; i < f.length; i++) {
      if (f[i].b === 1) { sawBoat = true; } else { sawBody = true; }
    }
    return sawBoat && sawBody;
  }

  /* Name the axis the CUSTOMER is about to choose, not the row the chart
     happens to print. "Body measurements: M" is a chart heading; the buy box
     says Size, and a skirt says Cockpit Size and Tunnel Size. Alex, 2026-08-06:
     "it should not say body measurement but should say Size: M in
     correspondence with the product's size variant's name. This should be true
     across all selectors."

     "Cockpit Size:" already read this way -- it came from the option name
     through pickPills() -- so this brings the measurement lines into line with
     the boat lines rather than inventing a convention.

     Only the product page. report() calls this inside the wrapper fork, so the
     chart pages and the modal keep the chart heading, which is right there: on
     those surfaces the table IS the subject and no product option exists.

     A table that pairs to no option on this product keeps its chart label.
     Guessing one would be worse than the heading it replaced, and the pairing
     rule that decides it is the same one that moves the pill -- so the label a
     customer reads can never name a different axis from the one that changed.

     THE VALUE COMES FROM THE PILL, not from the chart, whenever a pill was set.
     They are not always spelled the same: `childs-sunsuit-sizing` prints
     "6-9m" with an en dash where the product stocks "6-9M", and foldLabel()
     deliberately folds case and dash so the pill still lands. While the tail
     carried "We have selected Size 6-9M for you" the customer saw the real
     value somewhere; once that sentence went, showing only the chart's spelling
     meant the line and the cart disagreed on paper. Reading it back off
     `chosen` also means this cannot drift from what pickPills matched -- it is
     the same answer, not a second attempt at the same lookup.

     Declared ABOVE pdpWrap on purpose: everything from there down to pdpTail is
     held byte-identical by _build/test_pdp_regression_guard.js. */
  function pdpRelabel(wrap, data, rows, chosen) {
    var d = pdpData(wrap), out = [], i, k, opt, label, value, span;
    for (i = 0; i < rows.length; i++) {
      label = rows[i].l;
      value = rows[i].n;
      span = rows[i].span;
      if (d && d.opts) {
        opt = optionForTable(d, data, rows[i].t);
        if (opt) {
          label = opt.n;
          for (k = 0; chosen && k < chosen.length; k++) {
            if (chosen[k].n !== opt.n) { continue; }
            value = chosen[k].v;
            /* And it is no longer between sizes. Something else -- the boat
               picker, on a nylon skirt whose overlapping tunnel bands a waist
               can never narrow -- resolved this axis to ONE value, so printing
               "Cockpit Size: S (you are between sizes)" states a single size and
               then argues with it in the same breath. */
            span = false;
            break;
          }
        }
      }
      out.push(label + ': <b>' + value + '</b>'
        + (span ? ' (you are between sizes)' : ''));
    }
    return out;
  }

  /* OUTLET IS A VENDOR, and the vendor is the whole definition -- never a
     collection, a tag, or anything read off the visible page. The payload
     carries the raw vendor string and the normalising happens HERE, so the rule
     lives in exactly one place and block-size-recommender.liquid stays a data
     channel rather than a decision. Same reasoning as the axis map, which is
     resolved at runtime from the payload rather than baked into the snippet.

     Declared ABOVE pdpWrap deliberately. The two regions
     test_pdp_regression_guard.js holds byte-identical both START at pdpWrap's
     declaration, so a helper placed above it cannot disturb either claim --
     the same move as the 2026-08-06 helpers. Function declarations hoist, so
     the position costs nothing at runtime.

     This comment deliberately does NOT spell that declaration out in full.
     The guard brackets its regions with indexOf on the declaration text and
     does not strip comments, so writing the anchor here makes the region start
     inside this note and the guard fails on its own documentation. Same trap
     the no-id tripwire note further down avoids, key learnings 2026-07-31 --
     and it fired on the first run of this change. */
  function isOutlet(d) {
    return !!d && typeof d.vendor === 'string'
      && d.vendor.replace(/^\s+|\s+$/g, '').toLowerCase() === 'outlet';
  }

  function pdpWrap(root) {
    /* The `root.closest ?` guard is load-bearing, not stylistic: the root stub
       in _build/test_recommender_unit.js has no closest(), which is exactly how
       those 13 cases stay green and unmodified while proving the chart-page
       path is untouched. */
    if (!root || !root.closest) return null;
    return root.closest('.block-size-recommender');
  }

  function pdpData(wrap) {
    var el = wrap.querySelector('.ls-pdp-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function foldLabel(s) {
    /* Case, whitespace, dash, and a TRAILING parenthetical -- exactly the four
       relaxations _build/audit_pdp_size_vocabulary.py measures, so what the
       audit blesses and what this fires on cannot drift apart. Keep the two in
       step: the audit is what decides which products get an axis at all.

       The parenthetical is the nylon and neo-tour deck column, which prints
       "XS (1.2)" against a bare "XS" option value; the figure is chart
       annotation. Ruled foldable by Alex 2026-08-04. Only the TAIL is stripped,
       so a size whose name legitimately contains brackets is untouched.

       It does NOT reconcile "X-Large" with "Extra Large" -- that is a real live
       disagreement on `jack` and it wants a catalogue fix, not a normaliser
       quietly papering over it. */
    return String(s == null ? '' : s)
      .replace(/[\u2013\u2014\u2212]/g, '-')
      .replace(/\s*\([^)]*\)\s*$/, '')
      .split(' ').join('').toLowerCase();
  }

  function fireChange(el) {
    var ev;
    try { ev = new Event('change', { bubbles: true }); }
    catch (e) {
      ev = document.createEvent('HTMLEvents');
      ev.initEvent('change', true, false);
    }
    el.dispatchEvent(ev);
  }

  /* An option that sizes the BOAT rather than the person. Kept identical to
     OPT_IS_BOAT in _build/audit_pdp_size_vocabulary.py, which measures this
     exact rule against the live catalogue. */
  function optIsBoat(name) { return /cockpit|deck/i.test(String(name || '')); }

  function tableIsBoat(table) {
    var f = (table && table.f) || [], i;
    if (!f.length) return false;
    for (i = 0; i < f.length; i++) { if (f[i].b !== 1) return false; }
    return true;
  }

  function optionForTable(d, data, ti) {
    return axisMap(d, data)[ti];
  }

  /* NOTE ON PLACEMENT, and it is deliberate. axisMap, pairTable and
     labelAliases are declared AFTER optionForTable and BEFORE setPill, so they
     sit inside the region test_pdp_regression_guard.js already carves out as
     "optionForTable changed". Declared above optionForTable they would land in
     the `pdpWrap..optionForTable` region, whose byte-identity claim is still
     true and worth keeping. Same move as the 2026-08-06 helpers that went above
     pdpWrap or inside pdpTail's body for the same reason. Function
     declarations hoist, so the order costs nothing at runtime. */

  function axisMap(d, data) {
    /* Which option each table drives, decided for the WHOLE chart at once.

       Two tiers, and the order is the whole point. Every table gets its EXACT
       pairing first; only then may a table with no exact pairing claim an
       option through a dual-label alias, and only one that no exact pairing
       wanted. Two consequences, both deliberate:

       1. `womens-casual-sizing` is left exactly as it is today. It publishes
          Tops and Bottoms as two tables against one letter-valued Size option:
          Tops matches exactly and keeps it, Bottoms can only reach it through
          an alias and is refused. Alex deferred that chart on 2026-08-11
          ("women's casual sizing has tops and bottoms, so let's hold off"), and
          this ordering is what defers it -- no chart list, no per-chart flag.
          Without it, both tables would claim Size, pickPills()'s injectivity
          guard would refuse BOTH, and three products that preselect correctly
          today would stop (clearwater-tankini-2, zantanna-one-piece-swimsuit on
          CA, zantanna-one-piece-swimsuit-copy on EU). Measured, not predicted.

       2. A COMBINED size can never be split, whatever its spacing. club-sizing
          and mitts-sizing print "S/M" and their products carry "S/M" verbatim,
          so the exact tier claims it and the alias tier is never consulted.

       Resolved per call rather than cached: a chart has one to three tables and
       every consumer must see the same answer. Key learnings 2026-08-03 -- the
       unit defect shipped twice because one derivation had two copies. */
    var n = (data.t || []).length, exact = [], claimed = {}, out = [], i, a;
    for (i = 0; i < n; i++) {
      exact[i] = pairTable(d, data, i, false);
      if (exact[i]) claimed[exact[i].n] = true;
    }
    for (i = 0; i < n; i++) {
      if (exact[i]) { out[i] = exact[i]; continue; }
      a = pairTable(d, data, i, true);
      out[i] = (a && !claimed[a.n]) ? a : null;
    }
    return out;
  }

  function labelAliases(s) {
    /* A DUAL label is one size wearing two names, and both are the size.
       `mens-casual-bottom-sizing` prints "M / 32" and `womens-casual-bottom-
       sizing` prints "M / 8" -- the letter and the nominal waist -- and the
       caption says so: "The number beside each letter size is the nominal waist
       in inches." Products carry ONE of the two systems and which one varies,
       so "M / 32" has to be able to match a "32" pill and an "M" pill alike.
       Alex, 2026-08-11: "correct the selector so it is able to see that 32
       within the string and match ... the size chart needs to remain the same."

       This is NOT the "X-Large" vs "Extra Large" case foldLabel refuses. That is
       two authorities DISAGREEING about one size and only one can be right, so
       normalising it hides which. Here one authority prints two names on purpose,
       and says so in the caption.

       ONLY a SPACED slash splits. `club-sizing` and `mitts-sizing` print "S/M"
       and "L/XL", which are COMBINED sizes -- one size spanning small-to-medium,
       not two names -- and splitting those would offer "S" for a size that is
       not S. Measured over the corpus: 15 distinct slash labels, 13 dual and all
       spaced, 2 combined and both unspaced. The spacing is only the first guard;
       the load-bearing one is that a combined label matches its product value
       EXACTLY, and axisMap() never reaches for an alias when an exact match
       exists. */
    var out = [foldLabel(s)], str = String(s == null ? '' : s), parts, i, f;
    if (str.indexOf(' / ') === -1) return out;
    parts = str.split('/');
    for (i = 0; i < parts.length; i++) {
      f = foldLabel(parts[i]);
      if (f && out.indexOf(f) === -1) out.push(f);
    }
    return out;
  }

  function valueForLabel(opt, label) {
    /* Which of this option's VALUES does a chart label name? Null if none.

       Three tiers, weakest last, and the third is why this function exists:
       pairing a table to an option is only half the job. optionForTable() can
       say "this table drives Size" and this lookup still has to turn "M / 32"
       into the literal "32" the radio carries. Shipped 2026-08-11 with only the
       first two tiers, and the result was exactly as bad as it sounds -- the
       table paired, the result line correctly read "Size: M / 32", and then the
       lookup returned null, so setPill() was never called, `chosen` stayed
       empty and the Add To Cart button never appeared. Alex, on both live
       stores: "neither ca or com are populating the add to cart. Size selection
       is working however."

       The lesson is the one this file keeps relearning: a rule that spans two
       functions has to land in both. optionForTable and this lookup are the two
       halves of "can the customer act on the answer", and only the first was
       changed. */
    var j, want, al;
    for (j = 0; j < opt.v.length; j++) {
      if (opt.v[j] === label) { return opt.v[j]; }
    }
    want = foldLabel(label);
    for (j = 0; j < opt.v.length; j++) {
      if (foldLabel(opt.v[j]) === want) { return opt.v[j]; }
    }
    al = labelAliases(label);
    if (al.length > 1) {
      for (j = 0; j < opt.v.length; j++) {
        if (al.indexOf(foldLabel(opt.v[j])) !== -1) { return opt.v[j]; }
      }
    }
    return null;
  }

  function pairTable(d, data, ti, useAliases) {
    /* Which product option does chart table `ti` drive?

       Step 1, AXIS: `b` is written by the generator from the chart's own
       structure, so which side of the boat/paddler divide a table sits on is
       declared chart data. A boat table may only drive a cockpit/deck-named
       option and a body table may only drive one that is not. This filter runs
       BEFORE any value is compared, which is what makes a crossed pairing
       unreachable rather than merely detectable: the nylon skirts publish the
       SAME size run for their tunnel and deck tables, so on value alone a waist
       answer would set the cockpit pill. Alex ruled that out 2026-08-04, and
       measured live it is the whole catalogue's answer -- the audit needs no
       hand-written overrides once this filter exists.

       Step 2, OVERLAP: among axis-compatible options only, the one sharing the
       most labels with the table's full run. Overlap, not sequence equality --
       a product stocks a subset of its chart's sizes.

       Step 3, REFUSE ON A TIE.

       `useAliases` runs the same comparison against labelAliases() instead of
       the folded label alone. axisMap() decides when that is allowed; this
       function never decides it for itself. */
    var table = data.t[ti], boat = tableIsBoat(table), sizes = table.s || [];
    var mixed = tableIsMixed(table);
    var best = null, bestN = 0, tied = false, i, j, k, o, n;

    for (i = 0; i < d.opts.length; i++) {
      o = d.opts[i];
      if (!mixed && optIsBoat(o.n) !== boat) continue;
      n = 0;
      for (j = 0; j < sizes.length; j++) {
        var seen = 0, al = useAliases ? labelAliases(sizes[j])
                                      : [foldLabel(sizes[j])];
        for (k = 0; k < (o.v || []).length; k++) {
          if (al.indexOf(foldLabel(o.v[k])) !== -1) seen++;
        }
        if (seen === 1) n++;
      }
      if (n > bestN) { best = o; bestN = n; tied = false; }
      else if (n === bestN && n > 0) { tied = true; }
    }
    return (tied || bestN === 0) ? null : best;
  }

  /* THE one place a pill is moved. Both callers -- the measurement recommender
     and the boat finder -- go through here.

     Deliberately not duplicated. Key learnings 2026-08-03: the cm/inch defect
     shipped TWICE because the fix landed in one of two copies of the same
     derivation, and a third copy was sitting untouched in a fallback path. A
     second implementation of "check the right radio" is the same trap, and its
     failure mode is a wrong-size order rather than a wrong unit. */
  function setPill(scope, position, value) {
    var radios = scope.querySelectorAll('input[type="radio"][data-index]'), j, el;
    for (j = 0; j < radios.length; j++) {
      if (radios[j].getAttribute('data-index') === 'option' + position
          && radios[j].value === value) { el = radios[j]; break; }
    }
    if (!el) return null;

    /* An already-correct pill is a SUCCESS, not a skip. It used to bail here,
       which meant a second press of Suggest my size -- same measurements, same
       answer -- reported nothing chosen, so the Add to cart button vanished on
       every press after the first. Alex found it live, 2026-08-04.

       Only the EVENT is conditional: re-dispatching change on an unchanged
       radio re-runs the variant picker and rewrites the URL for nothing. */
    if (!el.checked) {
      el.checked = true;
      fireChange(el);
    }
    /* Sold-out values carry data-disabled, not the native disabled attribute,
       so they stay selectable. Alex, 2026-08-04: select it anyway -- it is the
       honest answer and it surfaces the back-in-stock path -- but say so. */
    return { oos: el.hasAttribute('data-disabled') };
  }

  function pickPills(wrap, picks, data, d) {
    if (!d || !d.opts) return null;

    /* Scope to the SECTION, never the document. Quick shop clones the whole
       product section, ids and all, so a document-wide lookup from inside a
       clone reaches the base page's radio. Same reason this sets .checked and
       dispatches its own event instead of calling label.click(): native label
       activation resolves its control through document.getElementById. */
    var scope = wrap.closest ? wrap.closest('[data-section-id]') : null;
    if (!scope) return null;

    /* Matched on data-index + value, NEVER on element id.
       variant-button.liquid stamps every size radio with
       data-index="option<position>" and value="<option value>", both stable.
       Going through element ids instead would mean the snippet had to reproduce
       that template's id formula character-for-character forever -- and it would
       put an id-attribute selector in this file, which the generator forbids in
       chart markup precisely because quick shop clones it. The rail caught this
       (test_no_id_attributes_in_output), and the rule was right. Note the test
       greps the rendered body, comments included, so this note deliberately
       avoids spelling the attribute-equals form -- key learnings 2026-07-31:
       a source-level tripwire that does not strip comments fires on its own
       documentation. */
    var chosen = [], oos = [], claimed = {}, i, p, optName, opt, hit;

    /* Injectivity: two tables may not drive one option. Found live on
       splash-neoprene-bungee-rand-spray-skirt, whose chart publishes an
       identical run for the waist table and the boat table against a single
       Cockpit Size option. The axis filter already separates those two, but a
       chart that ever put two SAME-side tables on one option would still be
       unanswerable, so refuse rather than let the last one win. */
    for (i = 0; i < picks.length; i++) {
      opt = optionForTable(d, data, picks[i].t);
      if (opt) { claimed[opt.n] = (claimed[opt.n] || 0) + 1; }
    }

    for (i = 0; i < picks.length; i++) {
      p = picks[i];
      opt = optionForTable(d, data, p.t);
      if (!opt || !opt.v) continue;         /* no axis-compatible option: no-op */
      if (claimed[opt.n] > 1) continue;     /* contested: refuse, stay textual */
      optName = opt.n;

      hit = valueForLabel(opt, p.label);
      if (hit === null) continue;   /* the chart names a size this product does
                                       not carry: degrade to the textual answer */

      var set = setPill(scope, opt.p, hit);
      if (!set) continue;
      chosen.push({ n: optName, v: hit });
      if (set.oos) { oos.push({ n: optName, v: hit }); }
    }

    return { chosen: chosen, oos: oos };
  }

  /* The theme's own button classes, so these match the product page by
     construction rather than by copying values that a theme update would move.
     block-buy-buttons.liquid uses `btn btn--primary` on Add to cart. */
  function btnHtml(tag, attrs, text) {
    return '<' + tag + ' class="btn btn--primary ls-pdp-btn" ' + attrs + '>'
      + text + '</' + tag + '>';
  }

  function dealerBtn(d) {
    return btnHtml('a', 'href="' + ((d && d.dealer) || DEALER_FALLBACK) + '"',
                   'Find your local dealer');
  }

  function addToCartBtn() {
    return btnHtml('button', 'type="button" data-ls-add="1"', 'Add Size To Cart');
  }

  /* ONE state, ONE message, ONE button.
     Alex, 2026-08-04, reviewing the first build: the out-of-stock case was
     stacking three paragraphs -- the best-estimate caveat, the selection
     confirmation and the stock warning -- and the between-sizes case said "you
     are between sizes" twice, once in the result line and again opening the
     tail. So this REPLACES the tail rather than appending to it, and the
     duplicate opener is gone: the result line above already says it. */
  /* "Cockpit Size Large and Tunnel Size M" from [{n,v},...]. The pairs are kept
     structured rather than pre-joined because the skirt branch above needs them
     as separate labelled lines, and re-splitting a sentence to get them back
     would be a parser waiting to break on an option name containing "and". */
  function phrase(list) {
    var out = [], i;
    for (i = 0; i < list.length; i++) { out.push(list[i].n + ' ' + list[i].v); }
    return out.join(' and ');
  }

  function pdpTail(wrap, picks, data, mail, haveLines, unclear, note, down,
                   spans, between, resolved, blocked) {
    var d = pdpData(wrap);
    var box = wrap.querySelector('.ls-fit');
    var scope = wrap.closest ? wrap.closest('[data-section-id]') : null;
    var i, key;

    /* Declared inside pdpTail on purpose. Everything from pdpWrap() down to
       this function is held byte-identical by the confinement check in
       _build/test_pdp_regression_guard.js, so a new top-level helper there
       would break a proof that is worth more than the tidier placement. */
    function lineList(list) {
      var out = [], n;
      for (n = 0; n < list.length; n++) {
        out.push(list[n].n + ': <b>' + list[n].v + '</b>');
      }
      return out;
    }
    function stateLines(list) { return lineList(list).join('<br>'); }

    /* The caveat as its own line rather than a clause. `why` is built with a
       leading space for the branches that run it on into a sentence; the Add To
       Cart button is display:block with its own margins, so a caveat placed
       immediately before it needs no separator of its own. */
    function lead(w) { return w ? w.replace(/^\s+/, '') : ''; }

    /* The caveat and the customer-service route. Declared HERE, above every
       branch that states an answer, rather than below the skirt branch where it
       used to sit -- thirteen lines out of that branch's reach, so a skirt
       customer whose waist runs off the end of the chart was handed a pill, a
       button and no warning at all. The between-sizes and out-of-stock branches
       dropped it for the same reason. Alex, 2026-08-06, Test G. */
    var closer = down
      ? ' If you would prefer a closer fit, email ' + mail
        + ' and we will check whether ' + down + ' will work for you.'
      : '';
    /* THE OUT-OF-RANGE ROUTING RIDES WITH THE CAVEAT, 2026-08-18.

       Overriding the tail after pdpTail returns was the obvious way to do this
       and it was wrong: the skirt branch puts the ANSWER inside its own tail
       (`stateLines(res.chosen)`), so replacing that tail deleted the deck size
       and the add-to-cart button with it. Measured by probe_pdp_render_branches
       before this: 336 runs on navigator-spray-skirt and cockpit-cover-copy
       where the pill carried a size that appeared nowhere in the output. That is
       the 2026-08-06 substitution defect rebuilt by hand, one branch over.

       `why` already carries `note` and is already rendered by every branch with
       anything to qualify, so the sentence lands correctly in all of them and no
       answer is touched. `note` is NOT repeated here -- pdpTail already prints
       it -- so blockedAdvice gets an empty lead and contributes only the
       routing half. */
    var why = (note ? ' ' + note.replace(/\s+$/, '') : '')
      + (blocked ? ' ' + blockedAdvice('', mail) : '') + closer;

    /* On a skirt the boat picker owns the cockpit axis and the waist owns the
       tunnel, so both contribute to one answer. */
    var boat = (box && scope) ? boatResolve(wrap, box, scope) : null;
    if (boat && boat.need) {
      /* The caveat DOES belong here, against the first reading of this branch.
         It is not an unnamed size: this branch returns a plain string, so
         report() keeps its own result lines, and the tunnel size the note talks
         about is on screen directly above. The customer has simply not filled in
         the boat half of the form yet, and the layering advisory is the most
         useful thing on the page for them. */
      return 'Choose your kayak brand and model so we can match the deck to '
        + 'your cockpit.' + why;
    }
    if (boat && boat.nofit) {
      /* And it does NOT belong here. No skirt in the range fits this boat, so
         there is nothing to size up into and nothing to buy; how the tunnel
         would have fitted is noise attached to a dead end. */
      return 'We do not have a skirt that fits that boat. Email ' + mail
        + ' and we will check, or try one on at a local dealer.' + dealerBtn(d);
    }

    /* `picks` already excludes every table that straddled -- report() adds a
       table only when it resolved to ONE size -- so running pickPills under
       `unclear` cannot preselect an uncertain answer. The `!unclear` gate that
       used to be here threw away the CERTAIN half of a two-axis answer instead:
       on the six skirts whose tunnel bands deliberately overlap, that table can
       never resolve, so the flag was permanently raised and the cockpit size the
       customer named their kayak to find was discarded on every lookup. Alex,
       2026-08-06: "only a tunnel size is offered up and not a cockpit size." */
    var res = picks.length ? pickPills(wrap, picks, data, d) : null;
    if (boat && boat.chosen && boat.chosen.length) {
      res = res || { chosen: [], oos: [] };
      res.chosen = boat.chosen.concat(res.chosen);
      res.oos = boat.oos.concat(res.oos);
      haveLines = true;      /* the boat IS an answer, even with no measurements */
    }
    var have = !!(res && res.chosen.length);
    /* Handed back before any branch returns, so the caller can title its result
       lines with the values that actually reached the pills. */
    if (resolved) { resolved.chosen = res ? res.chosen : []; }

    /* Which axes does report() ALREADY show as a result line? pdpRelabel()
       titles those lines with the option name, so restating one here prints the
       same answer twice -- the duplication Alex cut on 2026-08-04. A boat answer
       is never among them: the boat picker replaced the cockpit measurements, so
       that table has no values and produces no line, which is exactly why it has
       to be stated in the tail. */
    var shown = {}, opt;
    if (d && d.opts) {
      for (i = 0; i < picks.length; i++) {
        opt = optionForTable(d, data, picks[i].t);
        if (opt) { shown[opt.n] = 1; }
      }
      for (i = 0; spans && i < spans.length; i++) {
        opt = optionForTable(d, data, spans[i]);
        if (opt) { shown[opt.n] = 1; }
      }
    }
    function unshown(list) {
      var out = [], n;
      for (n = 0; n < list.length; n++) {
        if (!shown[list[n].n]) { out.push(list[n]); }
      }
      return out;
    }

    /* Has some axis already been resolved to a single value, from anywhere? */
    function answered(r, name) {
      var n;
      if (!r || !r.chosen) { return false; }
      for (n = 0; n < r.chosen.length; n++) {
        if (r.chosen[n].n === name) { return true; }
      }
      return false;
    }

    if (!haveLines) {
      return 'We could not place those measurements on this chart. Email '
        + mail + ' and we will help.' + dealerBtn(d);
    }

    /* Does a straddled table decide anything ON THIS PRODUCT? A chart table
       that pairs to no option here is decoration. The nylon and neo-tour skirts
       print a tunnel row against a product carrying only Cockpit Size, and its
       bands overlap by design (nylon XS and S are both 50 to 105 cm), so it can
       never resolve and never needs to. Only a straddle on an axis the customer
       must actually choose should hold the answer back. */
    var blocking = false, sopt;
    if (unclear) {
      blocking = !d || !d.opts;
      for (i = 0; !blocking && spans && i < spans.length; i++) {
        sopt = optionForTable(d, data, spans[i]);
        if (!sopt) { continue; }
        /* ALREADY ANSWERED. A straddle only holds things back if the axis it
           lands on is still unchosen. On a nylon skirt the merged table pairs to
           Cockpit Size and its tunnel bands overlap by design (XS and S are both
           50 to 105 cm), so a waist ALONE can never narrow it -- but the boat
           picker answers that same axis exactly. Without this the customer named
           their kayak, got the right pill set, and was told to go and measure
           again: the answer was there and the page argued with it.
           Found by rendering the page rather than by a gate, 2026-08-06. */
        if (answered(res, sopt.n)) { continue; }
        blocking = true;
      }
    }

    if (blocking) {
      /* ADDITIVE. Say what we DID resolve before handing the rest to a person:
         returning the hand-off on its own is what buried a resolved cockpit size
         under a "measure again" message. No Add To Cart -- an axis is still
         unchosen, so there is no complete variant to add. */
      /* `extra` rather than the head of the tail. An axis we are STATING belongs
         with the other result lines, and report() puts a blank line between the
         lines and the tail -- so prepending it here printed
             Tunnel Size: L/XL
             <blank>
             Cockpit Size: X-Large
             the sentence, hard against it
         which groups the second size with the paragraph instead of the first.
         Alex, 2026-08-06: "spacing is weird on this." */
      var alsoKnown = have ? unshown(res.chosen) : [];
      return {
        extra: lineList(alsoKnown),
        tail: (between
          /* Same sentence as the chart page. On a neoprene tunnel the two sizes
             are a choice the customer can make; telling them to measure again
             would be sending them away from an answer we already have. */
          ? layerAdvice(between, mail)
          : 'Open the size chart and measure again with the tape snug and '
            + 'level. If you are still unsure, email ' + mail + ' and our '
            + 'customer service team will place you, or try one on at a local '
            + 'dealer.')
          + dealerBtn(d) + why,
      };
    }
    /* SKIRTS: the answer, and nothing else.
       Alex, 2026-08-04: "a simple Tunnel Size: and Cockpit Size: under it with
       the add to cart button under it will suffice if there is a clean
       suggestion." The boat picker gives a definite answer -- the customer
       named their kayak -- so the hedging that suits a measurement estimate is
       just noise here. `replace` drops report()'s own result lines too, which
       would otherwise restate the tunnel in the chart's own wording.
       The caveat is not hedging: it is the one thing on this branch the
       customer cannot work out from the sizes in front of them. */
    if (boat && boat.isBoat && have && !res.oos.length) {
      return {
        replace: true,
        tail: stateLines(res.chosen) + (why ? '<br>' + lead(why) : '')
          + addToCartBtn(),
      };
    }

    if (!have) {
      /* A clean answer we could not put on a pill -- the chart names a size
         this product does not carry, or nothing axis-compatible matched. No
         button: there is nothing to add and no reason to send them to a dealer. */
      return 'This is our best estimate from the measurements you entered, not '
        + 'a guarantee of fit. If you are unsure, email ' + mail
        + ' and we will help.' + why;
    }
    if (res.oos.length) {
      /* ADDITIVE, but only over the axes still buyable. Restating a sold-out
         Size directly above "Size M is out of stock" would rebuild the three
         paragraph stack Alex cut on 2026-08-04, so a single-axis product reads
         exactly as it does today. What that cut lost was the OTHER axis: a Club
         customer whose Cockpit Size is sold out never saw the Tunnel Size we
         had already selected for them, which is the whole of the report. */
      /* STATE EVERY AXIS report() has not already printed, sold out or not.
         Alex, 2026-08-06, from the live page: "the answer is right but the
         Cockpit Size field should still come up under tunnel size. The message
         is correct, but the field dropped." It had been filtered out for being
         out of stock, which confuses two questions -- WHAT SIZE ARE YOU, and CAN
         YOU BUY IT TODAY. The stock sentence below answers the second; dropping
         the line left the first one unanswered on screen.
         `unshown` still keeps a single-axis product from printing "Size: M"
         immediately above "Size M is out of stock", which is the duplication
         Alex cut on 2026-08-04. */
      var still = unshown(res.chosen);
      /* OUTLET IS CLEARANCE, so the standard sentence makes a promise the
         business cannot keep. "We will tell you when it is back" is true of a
         current-season line and false of clearance: the stock is not coming
         back, and on an Outlet parent a missing size is often one that was
         never carried in that colour at all rather than one that sold through.
         The customer cannot tell those two apart and neither can this code,
         which is why the sentence names both and claims neither.

         The SELECTION is unchanged. Alex, 2026-08-04, still stands -- select
         the sold-out value anyway, because it is the honest answer -- and
         2026-08-12 changes only what we then say about it. The axis lines from
         `unshown` are also unchanged, for the 2026-08-06 reason: what size are
         you and can you buy it today are two questions, and this branch is
         only re-answering the second. */
      if (isOutlet(d)) {
        return {
          extra: lineList(still),
          tail: 'Unfortunately ' + phrase(res.oos)
            + (res.oos.length > 1 ? ' are ' : ' is ')
            + 'either not available or sold out for this product.'
            + dealerBtn(d) + why,
        };
      }
      return {
        extra: lineList(still),
        tail: phrase(res.oos) + (res.oos.length > 1 ? ' are ' : ' is ')
          + 'out of stock right now. Email ' + mail + ' and we will tell you '
          + 'when ' + (res.oos.length > 1 ? 'they are' : 'it is')
          + ' back, or try one on at a local dealer.' + dealerBtn(d) + why,
      };
    }
    /* Button ABOVE the confirmation sentence here, and BELOW it in the dealer
       cases. Alex, 2026-08-04. The reasoning holds up: when we have placed the
       customer, the action is the point and the sentence is the caveat; when we
       could not, the explanation has to come first or the button is an answer
       to a question they have not been asked yet. */
    /* SUPERSEDED, and kept because the argument was reasonable and someone will
       otherwise re-derive it: this used to read "the caveat comes LAST because
       it is the reason to hesitate, and a reason to hesitate placed above the
       button is an argument against pressing it" (2026-08-06, morning).

       Alex ruled the other way the same day, after seeing it live: the caveat
       belongs directly under the size, above the button. Below the button it
       reads as small print after the decision has been made, and it is the one
       thing on the screen the customer cannot work out for themselves. It is
       also where report() already puts it on the chart pages, so the product
       page stops being the odd surface out. */
    /* No confirmation sentence. It used to read "We have selected Size M for
       you. Change it any time." -- written when the result line above still said
       "Body measurements: M" and the customer had no other way to connect the
       answer to the pill that had moved. Now that the line names the option
       itself, the sentence repeats three of its own words directly under it.
       Alex, 2026-08-06, ruling on the label change: drop it. */
    return lead(why) + addToCartBtn();
  }

  /* The intro line is generated per chart and is SHARED with the chart pages
     and the modal, so it cannot be changed in the generator without changing
     them too. Rewriting it here keeps the edit inside the PDP block: the
     selector cannot match anywhere else, because .block-size-recommender only
     exists in the product-page block. Idempotent, so the 1.2s re-init is a
     no-op. Alex's copy, 2026-08-04. */
  var PDP_INTRO =
    'Don\'t want to read the size chart? Try our size selector below.';

  function pdpIntro() {
    var els = document.querySelectorAll('.block-size-recommender .ls-fit-intro');
    for (var i = 0; i < els.length; i++) {
      if (els[i].textContent !== PDP_INTRO) { els[i].textContent = PDP_INTRO; }

      /* Relocated to sit directly under the Size chart button, where it works
         as a signpost pointing DOWN at the selector -- hence "below". Left
         inside the widget it was introducing something the customer had
         already found. Alex, 2026-08-04.

         The move is idempotent (a second run finds it already in place) and it
         is not viewport-dependent, so it does not repeat the 2026-07-31 trap
         where a "mobile only" node move survived the window being widened. If
         the size-chart block is absent or ordered differently, the guard leaves
         the line exactly where it was. */
      var sec = els[i].closest ? els[i].closest('[data-section-id]') : null;
      var trig = sec
        ? sec.querySelector('tool-tip-trigger[data-tool-tip="size-chart"]') : null;
      var anchor = trig
        ? (trig.closest ? trig.closest('.size-chart__standalone') || trig : trig)
        : null;
      if (anchor && anchor.parentNode
          && els[i].previousElementSibling !== anchor) {
        els[i].classList.add('ls-pdp-intro-moved');
        anchor.parentNode.insertBefore(els[i], anchor.nextSibling);
      }
    }
  }

  /* "Not sure how to measure?" OPENS the chart rather than pointing at the
     button. The diagram and the how-to-measure list are hidden in this block
     (that is the point of the block) but they are the answer to that exact
     question, and they are already on the page inside the size-chart modal.
     Pointing at a button is also fragile: the recommender now renders BELOW the
     Size chart button, so "click the button below" would be wrong. */
  var PDP_HOWTO = 'Not sure how to measure? Open the size chart.';
  /* On a skirt the customer is not measuring anything -- they are looking for
     their kayak in a list -- so the escape hatch has to answer the question
     they will actually have. Alex, 2026-08-04. */
  var PDP_HOWTO_BOAT = 'Don\'t see your boat listed? Use the size chart.';
  var SIZE_REQUEST_URL = '/pages/skirt-size-request';
  var SIZE_REQUEST_TEXT = 'Submit a sizing request';

  /* ---- BOAT FINDER (spray skirts) ---------------------------------------
     Alex, 2026-08-04: on a skirt product page the customer should find their
     size by naming their KAYAK, not by measuring its cockpit rim -- with the
     material and skirt-model dropdowns gone, because standing on this product
     page has already chosen both.

     So on a skirt the widget becomes: Manufacturer, Model, and (where the
     product sells one) a waist size. The boat resolves the cockpit pill; the
     waist resolves the tunnel pill through the chart the recommender already
     solves. Two axes, one Add to cart.

     THE CRITICAL DESIGN POINT: a boat resolves to a VARIANT ID, and the pill is
     set from THAT VARIANT'S OWN option value -- never from the selector's size
     string. Measured live across all 11 skirts, the selector's "Extra Large"
     has to become "X-Large" on four products, "Extra Large" on one and "XL" on
     another; "Large" becomes "Large" on five and "L" on one. No single lookup
     table is right for all of them, and a plausible one would mis-size orders
     quietly. The variant id is exact.

     Data: assets/ls-skirt-boats-<handle>.json, a per-product subset (~85 KB
     against the full selector file's 610 KB) carrying only the boats that fit
     THIS skirt, with dead-end manufacturers and models already dropped. */

  var boatCache = {};

  function boatLoad(url) {
    if (!boatCache[url]) {
      boatCache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        });
    }
    return boatCache[url];
  }

  function fillSelect(sel, keys, placeholder) {
    var html = '<option value="">' + placeholder + '</option>', i;
    for (i = 0; i < keys.length; i++) {
      html += '<option value="' + keys[i].replace(/"/g, '&quot;') + '">'
           + keys[i] + '</option>';
    }
    sel.innerHTML = html;
    sel.disabled = keys.length === 0;
  }

  function sortedKeys(obj) {
    var out = [], k;
    for (k in obj) { if (Object.prototype.hasOwnProperty.call(obj, k)) out.push(k); }
    return out.sort();
  }

  function boatBuild(box, data) {
    if (box.querySelector('.ls-boat')) return;          /* idempotent */

    /* Drop the fields measured ON THE BOAT. The picker supplies that axis now,
       and leaving them would make report() demand cockpit dimensions the
       customer came here precisely to avoid measuring. Removal, not hiding:
       report() collects by querySelectorAll, so a hidden field still reads as
       missing. Fields measured on the PADDLER -- the tunnel/waist -- stay. */
    var src = box.querySelector('.ls-fit-data'), payload = null;
    try { payload = JSON.parse(src.textContent); } catch (e) { payload = null; }
    if (payload) {
      var boatLabels = {}, ti, fi, f;
      for (ti = 0; ti < payload.t.length; ti++) {
        f = payload.t[ti].f || [];
        for (fi = 0; fi < f.length; fi++) {
          if (f[fi].b === 1) { boatLabels[f[fi].l] = 1; }
        }
      }
      var fields = box.querySelectorAll('input[data-ls-f]'), i, lab;
      for (i = fields.length - 1; i >= 0; i--) {
        if (!boatLabels[fields[i].getAttribute('data-ls-f')]) continue;
        lab = fields[i].closest ? fields[i].closest('.ls-fit-f') : null;
        if (lab && lab.parentNode) { lab.parentNode.removeChild(lab); }
      }
    }

    var grid = box.querySelector('.ls-fit-grid');
    if (!grid) return;

    var wrapEl = document.createElement('div');
    wrapEl.className = 'ls-boat';
    /* A search box ABOVE each dropdown, narrowing it, rather than a combobox
       replacing it. Alex, 2026-08-06: type to search as well as pick from the
       list -- 113 brands and 1,332 models is a lot to scroll.

       Why not a real combobox: ARIA wires one up with aria-controls and
       aria-activedescendant, and BOTH are id references. Ids are forbidden in
       this markup because quick shop clones the whole product section, so a
       cloned reference binds to whichever copy appears first in the document --
       the same failure that made label.click() unusable for the pills. Keeping
       the native <select> as the control keeps every keyboard, screen-reader
       and mobile-picker behaviour the browser already provides, and needs no id
       at all.

       The search input carries NEITHER `ls-pdp-sel` (the change handler would
       try to write its text into a measurement input) NOR `data-ls-f`
       (report() would then refuse to answer until it was filled in). */
    var brands = sortedKeys(data.tree);
    wrapEl.innerHTML =
      '<label class="ls-fit-f ls-boat-f"><span>Kayak brand</span>'
      + '<input type="text" class="ls-boat-find" autocomplete="off"'
      + ' role="combobox" aria-expanded="false" aria-autocomplete="list"'
      + ' placeholder="Type to search ' + brands.length + ' brands">'
      + '<ul class="ls-boat-list" role="listbox" hidden></ul>'
      + '<select class="ls-pdp-sel ls-boat-mfr"></select></label>'
      + '<label class="ls-fit-f ls-boat-f"><span>Kayak model</span>'
      + '<input type="text" class="ls-boat-find" autocomplete="off" disabled'
      + ' role="combobox" aria-expanded="false" aria-autocomplete="list"'
      + ' placeholder="Choose a brand first">'
      + '<ul class="ls-boat-list" role="listbox" hidden></ul>'
      + '<select class="ls-pdp-sel ls-boat-model" disabled></select></label>';
    grid.insertBefore(wrapEl, grid.firstChild);

    fillSelect(wrapEl.querySelector('.ls-boat-mfr'), brands,
               'Select your kayak brand');
    fillSelect(wrapEl.querySelector('.ls-boat-model'), [], 'Select your model');
  }

  /* ---- The type-to-search list -------------------------------------------
     Three small functions rather than one, because each is called from a
     different place: boatFilter renders it, the keydown handler moves through
     it, and a click commits from it. */

  function listFor(inp) {
    var lab = inp.closest ? inp.closest('.ls-boat-f') : null;
    return lab ? lab.querySelector('.ls-boat-list') : null;
  }

  function hideList(inp) {
    var ul = listFor(inp);
    if (!ul) return;
    ul.hidden = true;
    ul.innerHTML = '';
    inp.setAttribute('aria-expanded', 'false');
  }

  function showList(inp, keys) {
    var ul = listFor(inp), html = '', i;
    if (!ul) return;
    /* Nothing typed yet means "browse", and a 113-item list dropped over the
       page the moment the box is focused is a wall rather than a help. The
       native select below is the browse control. */
    if (!keys.length || !String(inp.value || '').trim()) {
      hideList(inp);
      return;
    }
    /* Capped, and the cap is STATED. A silent truncation reads as "that is
       everything", which on a brand list is how a customer concludes we do not
       cover their boat. */
    for (i = 0; i < keys.length && i < 12; i++) {
      html += '<li role="option" tabindex="-1" aria-selected="false">'
           + keys[i].replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</li>';
    }
    if (keys.length > 12) {
      html += '<li class="ls-boat-more" aria-disabled="true">'
           + (keys.length - 12) + ' more. Keep typing to narrow them.</li>';
    }
    ul.innerHTML = html;
    ul.hidden = false;
    inp.setAttribute('aria-expanded', 'true');
  }

  /* Commit a chosen row: fill the box, move the real select, tell the cascade,
     put focus back where the customer was typing. */
  function commitBoat(inp, text) {
    var lab = inp.closest ? inp.closest('.ls-boat-f') : null;
    var sel = lab ? lab.querySelector('select') : null;
    if (!sel) return;
    inp.value = text;
    hideList(inp);
    if (sel.value !== text) {
      sel.value = text;
      fireChange(sel);
    }
    if (inp.focus) { inp.focus(); }
  }

  /* Narrow one boat dropdown to what has been typed above it.
     REBUILT from the dataset on every keystroke rather than hiding <option>s:
     a hidden option is still reachable by keyboard in several browsers, and iOS
     Safari ignores the attribute outright, so hiding would leave the customer
     able to select something the filter says is not there. */
  function boatFilter(inp) {
    var lab = inp.closest ? inp.closest('.ls-boat-f') : null;
    var sel = lab ? lab.querySelector('select') : null;
    var box = inp.closest ? inp.closest('.ls-fit') : null;
    var bwrap = (box && box.closest)
      ? box.closest('.block-size-recommender') : null;
    var url = bwrap ? bwrap.getAttribute('data-ls-boats') : null;
    var data = url ? boatData[url] : null;
    if (!sel || !data || !data.tree) return;

    var isMfr = String(sel.className).indexOf('ls-boat-mfr') !== -1;
    var mfrEl = box.querySelector('.ls-boat-mfr');
    var all = isMfr
      ? sortedKeys(data.tree)
      : ((mfrEl && mfrEl.value) ? sortedKeys(data.tree[mfrEl.value] || {}) : []);

    var q = String(inp.value || '').toLowerCase().replace(/\s+/g, ' ').trim();
    var keep = [], i;
    for (i = 0; i < all.length; i++) {
      if (!q || all[i].toLowerCase().indexOf(q) !== -1) { keep.push(all[i]); }
    }

    /* SHOW the narrowing list. Alex, 2026-08-06: "when someone types in the
       kayak brand or boat search, the dropdown should open showing them options
       that narrow as they type." Filtering a CLOSED select changes nothing the
       customer can see, which is what the first version did.

       A sibling <ul role="listbox"> rather than opening the native picker:
       select.showPicker() takes the keyboard, so the second keystroke would not
       reach the box being typed in, and on a phone it throws a full-screen
       wheel on every letter. The native <select> stays underneath as the
       browse-everything control and as the value the rest of the code reads,
       so boatResolve(), the cascade and every existing test are untouched.

       NO ids anywhere: `aria-controls` and `aria-activedescendant` both take id
       references, and quick shop clones this whole section. The list is the
       input's next sibling and keyboard focus MOVES onto the highlighted option
       (tabindex -1), which is the id-free half of the combobox pattern. */
    showList(inp, keep);

    var was = sel.value;
    fillSelect(sel, keep, keep.length
      ? (isMfr ? 'Select your kayak brand' : 'Select your model')
      : 'No match, check the spelling');
    /* Three outcomes, and each one has to leave the cascade consistent.
       The old choice survived the filter, so keep it and say nothing. Exactly
       one thing matches, so make the choice for them. Otherwise the selection
       is GONE, and everything downstream -- the model list, the pill, the
       answer -- has to be told, or the page keeps showing a size derived from a
       boat that is no longer selected. */
    if (was && keep.indexOf(was) !== -1) {
      sel.value = was;
    } else if (keep.length === 1) {
      sel.value = keep[0];
      fireChange(sel);
    } else if (was) {
      fireChange(sel);
    }
  }

  function boatInit(box) {
    var wrap = box.closest ? box.closest('.block-size-recommender') : null;
    if (!wrap) return;
    var url = wrap.getAttribute('data-ls-boats');
    if (!url) return;                                   /* not a skirt */
    boatLoad(url).then(function (data) {
      boatData[url] = data;
      boatBuild(box, data);
    })['catch'](function () { /* leave the measurement form as-is */ });
  }

  var boatData = {};

  function boatResolve(wrap, box, scope) {
    var url = wrap.getAttribute('data-ls-boats');
    var data = url ? boatData[url] : null;
    if (!data) return null;
    var mfrEl = box.querySelector('.ls-boat-mfr');
    var modEl = box.querySelector('.ls-boat-model');
    if (!mfrEl || !modEl || !mfrEl.value || !modEl.value) {
      return { need: true };
    }
    var node = (data.tree[mfrEl.value] || {})[modEl.value];
    if (!node) { return { nofit: true }; }
    var v = (data.variants || {})[node.variant];
    if (!v || !v.options) { return { nofit: true }; }

    /* Set every option this variant names EXCEPT the tunnel -- that one belongs
       to the waist answer, and the dataset's tunnel value is meaningless here
       (every neoprene leaf in it is the M variant, whatever the boat). */
    var name, chosen = [], oos = [], set;
    for (name in v.options) {
      if (!Object.prototype.hasOwnProperty.call(v.options, name)) continue;
      if (/tunnel|waist/i.test(name)) continue;
      set = setPill(scope, optionPosition(wrap, name), v.options[name]);
      if (!set) continue;
      chosen.push({ n: name, v: v.options[name] });
      if (set.oos) { oos.push({ n: name, v: v.options[name] }); }
    }
    return { chosen: chosen, oos: oos, isBoat: true };
  }

  function optionPosition(wrap, name) {
    var d = pdpData(wrap), i;
    if (!d || !d.opts) return -1;
    for (i = 0; i < d.opts.length; i++) {
      if (d.opts[i].n === name) return d.opts[i].p;
    }
    return -1;
  }

  /* ---- Measurement dropdowns (Alex, 2026-08-04) --------------------------
     Free-number entry asks the customer to know their chest to the centimetre
     and then to guess which unit the box wants. Offering the values the chart
     actually distinguishes removes both problems, and it is where the unit
     belongs -- printed on each option rather than floated at the edge of a
     text field.

     It also fixes Height. In inches the chart's bands are TOTAL INCHES, so a
     customer who is six feet tall types "6" and gets placed at six inches. A
     dropdown can render 5'10" and hand the solver 70.

     The real <input data-ls-f> STAYS in the DOM and keeps carrying the value.
     report() finds its fields with querySelectorAll('input[data-ls-f]'), and
     widening that selector would break the stub in
     _build/test_recommender_unit.js -- the 13-case suite whose staying green
     and UNMODIFIED is the evidence that the chart-page path is untouched. The
     select is a control bolted alongside it, not a replacement for it. */

  /* EVERY table carrying this label, not the first one that happens to.

     A chart may publish the same measurement over two size runs: kids-casual
     grades Chest across a toddler run (43 to 71) and a youth run (63.5 to 86.5).
     The dropdown is built from what this returns, so taking only the first match
     made the toddler half of that chart UNREACHABLE -- there was no option a
     parent of a two-year-old could pick, on the one control that exists to place
     them. Same defect shape as the 2026-08-06 unreachable refusal: a correct
     answer nobody can select is not a feature.

     The inputs are deduped by label in the generator for the same underlying
     reason -- the reader keys values by label and cannot hold two. */
  function fieldBands(data, label, unit) {
    var out = null, i, j, f, b;
    for (i = 0; i < data.t.length; i++) {
      f = data.t[i].f || [];
      for (j = 0; j < f.length; j++) {
        if (f[j].l !== label) continue;
        b = (unit === 'in' && f[j]['in'] && f[j]['in'].length) ? f[j]['in'] : f[j].cm;
        if (b && b.length) { out = out ? out.concat(b) : b.slice(); }
      }
    }
    return out;
  }

  /* A field whose numbers are NOT centimetres or inches declares what they are.
     kids-pfd-sizing's Weight row is kilograms against pounds: the toggle still
     says cm / inches, because it switches the whole page, but a dropdown reading
     "14 cm" against a child's weight would be nonsense. Absent, the toggle's own
     unit is right and nothing changes -- so every other chart's body stays byte
     identical, the same rule the `nc` flag follows. */
  function fieldUnitText(data, label, unit) {
    var i, j, f;
    for (i = 0; i < data.t.length; i++) {
      f = data.t[i].f || [];
      for (j = 0; j < f.length; j++) {
        if (f[j].l !== label || !f[j].u) continue;
        return unit === 'in' ? f[j].u[1] : f[j].u[0];
      }
    }
    return null;
  }

  /* Is this field one the customer can be too big for? See solve()'s blocked
     branch. The dropdown has to know, because it is built FROM the chart's
     bands and therefore stops at the largest size's maximum -- so without this
     the refusal is unreachable: there is no option to pick that triggers it.

     Shipped that way for about an hour on 2026-08-06 and caught by asking
     "can a customer actually select this?" rather than by any gate. Both gates
     covering the refusal drive solve() directly with a value above the top,
     which is precisely the input the UI could not produce. Same lesson as the
     rest of this day's work, one layer further out: a correct answer nobody can
     reach is not a feature. */
  function fieldBlocks(data, label) {
    var i, j, f;
    for (i = 0; i < data.t.length; i++) {
      f = data.t[i].f || [];
      for (j = 0; j < f.length; j++) {
        if (f[j].l === label && f[j].bl) return true;
      }
    }
    return false;
  }

  function optionLabel(v, unit, isHeight, unitText) {
    if (isHeight && unit === 'in') {
      var ft = Math.floor(v / 12), inch = Math.round(v - ft * 12);
      if (inch === 12) { ft += 1; inch = 0; }
      return ft + '\'' + inch + '"';
    }
    return (Math.round(v * 10) / 10) + ' ' + (unitText || unit);
  }

  function buildOptions(sel, bands, unit, label, unitText, blocks) {
    var isHeight = /height/i.test(label || '');
    /* min and max across the WHOLE list, not its two ends. fieldBands may return
       the bands of more than one table, and those arrive in TABLE order, which is
       not size order -- kids-casual lists its youth run first, so the ends would
       have started the dropdown at 63.5 cm and hidden every toddler size. Reading
       the extremes cannot be wrong whatever order they arrive in. */
    var lo = bands[0][0], hi = bands[0][1], bi;
    for (bi = 1; bi < bands.length; bi++) {
      if (bands[bi][0] < lo) { lo = bands[bi][0]; }
      if (bands[bi][1] > hi) { hi = bands[bi][1]; }
    }
    /* Whole units for height (nobody reports half an inch of height) and for
       centimetres; half-inches elsewhere, which is the precision the printed
       charts themselves use. A declared unit is whole too: half a pound is not
       how anyone reports a child's weight, and the derived band edges land on
       fractions that would otherwise print as 19.8 lbs. */
    var step = (unit === 'in' && !isHeight && !unitText) ? 0.5 : 1;
    var html = '<option value="">Select</option>', v;
    for (v = Math.floor(lo); v <= Math.ceil(hi) + 0.0001; v += step) {
      html += '<option value="' + v + '">'
           + optionLabel(v, unit, isHeight, unitText) + '</option>';
    }
    /* ONE option past the end, and only on a row you can be too big for. The
       list is built from the chart's own bands, so it stops at the largest
       size's maximum -- which is exactly the value the refusal needs to be
       EXCEEDED. Without this there is no selectable input that produces it.

       A single "More than X" rather than a run of numbers: the chart publishes
       nothing above the top, so offering 131, 132, 133 would imply a precision
       that means nothing, and every one of them lands on the same answer. */
    if (blocks) {
      html += '<option value="' + (hi + 1) + '">More than '
           + (Math.round(hi * 10) / 10) + ' ' + (unitText || unit) + '</option>';
    }
    sel.innerHTML = html;
  }

  function pdpSelects(box) {
    var root = box.closest ? box.closest('.ls-sizechart') : null;
    if (!root) return;
    var src = box.querySelector('.ls-fit-data');
    if (!src) return;
    var data;
    try { data = JSON.parse(src.textContent); } catch (e) { return; }

    var unit = unitOf(root) === 'inches' ? 'in' : 'cm';
    var fields = box.querySelectorAll('input[data-ls-f]'), i, inp, sel, bands;

    for (i = 0; i < fields.length; i++) {
      inp = fields[i];

      /* The visible label. data-ls-f keeps the RAW string -- it is the key that
         matches an input to its band, and renaming a key to make it read better
         is how a lookup quietly stops matching. Only the text changes. */
      var lab = inp.parentNode ? inp.parentNode.querySelector('span') : null;
      if (lab) {
        var nice = cleanLabel(inp.getAttribute('data-ls-f'));
        if (lab.textContent !== nice) { lab.textContent = nice; }
      }

      bands = fieldBands(data, inp.getAttribute('data-ls-f'), unit);
      if (!bands) continue;
      sel = inp.parentNode ? inp.parentNode.querySelector('.ls-pdp-sel') : null;
      if (!sel) {
        sel = document.createElement('select');
        sel.className = 'ls-pdp-sel';
        inp.parentNode.insertBefore(sel, inp.nextSibling);
      }
      buildOptions(sel, bands, unit, inp.getAttribute('data-ls-f'),
                   fieldUnitText(data, inp.getAttribute('data-ls-f'), unit),
                   fieldBlocks(data, inp.getAttribute('data-ls-f')));
      /* Switching units invalidates whatever was chosen -- 42 inches is not 42
         centimetres, and silently reinterpreting it is the 2026-08-03 defect
         wearing a different hat. Clear both sides together. */
      sel.value = '';
      inp.value = '';
    }
  }

  /* EVERY recommender, not only the product-page one. Alex, 2026-08-04, after
     seeing it live: the dropdown should replace typed entry on the size chart
     pages too, on all three stores.

     This is the one thing in this whole change that DOES reach the chart pages
     and the modal, and it is deliberate. It does not disturb the
     product-page-only rule: report()'s output text is untouched -- the
     byte-identity guard still passes -- because this changes how a value is
     ENTERED, not what the answer says. */
  function allSelects() {
    var boxes = document.querySelectorAll('.ls-sizechart .ls-fit'), i;
    for (i = 0; i < boxes.length; i++) { pdpSelects(boxes[i]); }
  }

  /* Rebuild the dropdowns of EVERY recommender the toggled radio governs.
     A chart carries TWO unit toggles -- the table's, up in .ls-data, and the
     recommender's, inside .ls-fit -- and they deliberately share a radio NAME so
     the browser keeps them in sync with no JS at all.

     This used to rebuild `t.closest('.ls-fit')`, which the TABLE's toggle does
     not have. So switching units on the table left the dropdowns listing the old
     unit's numbers, and left anything already chosen holding the old unit's
     number, while unitOf() had already flipped: a 90 picked in centimetres was
     then read as 90 INCHES. On the nylon chart that turns "XS to 7XL" into "your
     waist is above the largest tunnel opening we make in this skirt". Reported by
     customers, via Alex, 2026-08-06. Same silent-wrong-answer shape as the
     2026-08-03 unit defect, through a different door.

     Matched on the radio NAME, because that is what the browser itself uses to
     decide which radios move together -- so it is exactly the set whose
     displayed unit just changed, including the hidden copy the size modal clones
     from, which fires no event of its own. A different chart in a quick shop
     clone carries a different name and is left alone rather than having its
     entries cleared. Compared by reading the attribute rather than by building a
     selector out of it: a value interpolated into a selector is a syntax error
     waiting for the first unusual unit_key. */
  function unitSelects(radio) {
    var name = radio && radio.getAttribute ? radio.getAttribute('name') : null;
    var boxes = document.querySelectorAll('.ls-fit'), i, j, root, radios, hit;
    for (i = 0; i < boxes.length; i++) {
      root = boxes[i].closest ? boxes[i].closest('.ls-sizechart') : null;
      if (!root) { continue; }
      hit = !name;
      radios = root.querySelectorAll('.ls-r');
      for (j = 0; !hit && j < radios.length; j++) {
        if (radios[j].getAttribute('name') === name) { hit = true; }
      }
      if (hit) { pdpSelects(boxes[i]); }
    }
  }

  function pdpHowTo() {
    var boxes = document.querySelectorAll('.block-size-recommender .ls-fit');
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].querySelector('.ls-pdp-howto')) continue;   /* idempotent */

      /* Anchored on the input grid, which never moves.
         It used to anchor on .ls-fit-intro -- and then pdpIntro() was taught to
         RELOCATE that paragraph out of the block to sit under the Size chart
         button. init() runs pdpIntro() first, so the anchor was gone by the
         time this ran and both links silently stopped rendering on every skirt
         page. Alex spotted it live, 2026-08-04.
         The lesson is the fix: do not anchor on an element another pass is
         allowed to move. */
      var anchor = boxes[i].querySelector('.ls-fit-grid');
      if (!anchor || !anchor.parentNode) continue;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ls-pdp-howto';
      b.setAttribute('data-ls-chart', '1');
      var hwrap = boxes[i].closest
        ? boxes[i].closest('.block-size-recommender') : null;
      var isBoat = !!(hwrap && hwrap.getAttribute('data-ls-boats'));

      /* AFTER the field grid, not before it. Before, they flowed inline beside
         the cm/inches toggle -- both are inline-level -- which read as chrome
         attached to the toggle rather than as a way out if the finder cannot
         help. Below the fields they are the next thing you look at when the
         model list did not contain your boat. Alex, 2026-08-04. */
      b.textContent = isBoat ? PDP_HOWTO_BOAT : PDP_HOWTO;
      anchor.parentNode.insertBefore(b, anchor.nextSibling);

      /* The last resort, and only where it applies: the request page is
         skirt-specific, so offering it on a garment would send the customer
         somewhere that cannot help them. */
      if (isBoat) {
        var a = document.createElement('a');
        a.className = 'ls-pdp-request';
        a.href = SIZE_REQUEST_URL;
        a.textContent = SIZE_REQUEST_TEXT;
        if (b.parentNode) { b.parentNode.insertBefore(a, b.nextSibling); }
      }
    }
  }

  function enable() {
    var boxes = document.querySelectorAll('.ls-sizechart .ls-fit');
    for (var i = 0; i < boxes.length; i++) { boxes[i].classList.add('ls-fit-on'); }
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.classList) return;

    if (t.classList.contains('ls-fit-go')) {
      var root = t.closest ? t.closest('.ls-sizechart') : null;
      if (root) { e.preventDefault(); report(root); }
      return;
    }

    /* "Add this size to your cart" drives the THEME's own submit button rather
       than posting to /cart/add itself. The size is already selected on the
       real variant picker, so the theme's button is holding the right variant
       id -- and clicking it keeps the drawer, the analytics and the sold-out
       handling that block-buy-buttons already owns. Reimplementing the add
       would fork all of that. */
    if (t.getAttribute && t.getAttribute('data-ls-add')) {
      e.preventDefault();
      var scope = t.closest ? t.closest('[data-section-id]') : null;
      var add = scope ? scope.querySelector('button[type="submit"][name="add"]') : null;
      if (add && !add.disabled) { add.click(); }
      return;
    }

    /* Open the size-chart modal by clicking the theme's OWN trigger, so the
       focus trap, the scroll lock and the snapshot behaviour are all the
       theme's. tool-tip-trigger binds its click to the title element; falling
       back to the custom element covers a future markup change. */
    if (t.getAttribute && t.getAttribute('data-ls-chart')) {
      e.preventDefault();
      var sc = t.closest ? t.closest('[data-section-id]') : null;
      if (!sc) return;
      var trig = sc.querySelector('tool-tip-trigger[data-tool-tip="size-chart"]');
      if (!trig) return;
      var title = trig.querySelector('.tool-tip-trigger__title');
      (title || trig).click();
      return;
    }
  });
  /* pdpIntro() is safe to call unconditionally: its selector is scoped to
     .block-size-recommender, which exists only inside the product-page block,
     so on a chart page and in the modal it matches nothing. */
  /* PDP-only change delegate. Bound to DOCUMENT, never inside the product
     section: block-variant-picker.js listens for change on its own element and
     calls updateMasterId(event.target) unconditionally, so a foreign input that
     reaches it strands the picker mid-update as an unhandled rejection. The
     recommender block is a sibling, so nothing here traverses it. */
  /* Type-to-search on the kayak dropdowns. Delegated for the same reason the
     change handler is: quick shop clones the section AFTER init has run, so a
     listener bound to an element never reaches the copy. */
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('ls-boat-find')) {
      boatFilter(t);
    }
  });

  /* Is this element a row of a boat search list? */
  function boatOption(t) {
    return !!(t && t.getAttribute && t.getAttribute('role') === 'option'
      && t.closest && t.closest('.ls-boat-list'));
  }
  function findBoxFor(t) {
    var lab = t && t.closest ? t.closest('.ls-boat-f') : null;
    return lab ? lab.querySelector('.ls-boat-find') : null;
  }

  /* Keyboard, which is the half of a search list that gets forgotten. Down from
     the box moves into the results, Up off the top returns to the box, Enter
     takes the row, Escape closes without choosing. Focus MOVES to the row --
     the alternative, aria-activedescendant, is an id reference and ids are
     forbidden in this markup. */
  document.addEventListener('keydown', function (e) {
    var t = e.target, isOpt = boatOption(t);
    var isFind = !!(t && t.classList && t.classList.contains('ls-boat-find'));
    if (!isFind && !isOpt) return;
    var inp = isFind ? t : findBoxFor(t);
    if (!inp) return;

    if (e.key === 'Escape') { hideList(inp); if (inp.focus) inp.focus(); return; }
    if (e.key === 'Enter' && isOpt) {
      e.preventDefault();
      commitBoat(inp, t.textContent);
      return;
    }
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var ul = listFor(inp);
    var opts = ul && !ul.hidden ? ul.querySelectorAll('li[role="option"]') : [];
    if (!opts.length) return;
    e.preventDefault();
    var at = -1, i;
    for (i = 0; i < opts.length; i++) {
      opts[i].setAttribute('aria-selected', 'false');
      if (opts[i] === t) { at = i; }
    }
    var next = e.key === 'ArrowDown' ? at + 1 : at - 1;
    if (next < 0) { if (inp.focus) inp.focus(); return; }
    if (next > opts.length - 1) { next = opts.length - 1; }
    opts[next].setAttribute('aria-selected', 'true');
    if (opts[next].focus) { opts[next].focus(); }
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (boatOption(t)) {
      var inp = findBoxFor(t);
      if (inp) { commitBoat(inp, t.textContent); }
      return;
    }
    /* A click anywhere else closes any list still open, including in a quick
       shop clone -- hence querySelectorAll over the document rather than a
       listener bound per instance. */
    var open = document.querySelectorAll('.ls-boat-find[aria-expanded="true"]'), i;
    var mine = t && t.closest ? t.closest('.ls-boat-f') : null;
    for (i = 0; i < open.length; i++) {
      if (open[i].closest && open[i].closest('.ls-boat-f') === mine) continue;
      hideList(open[i]);
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;

    /* Kayak brand chosen -- narrow the model list to boats that actually fit.
       This MUST be tested before the .ls-pdp-sel branch below: the brand select
       carries BOTH classes, so the generic branch matched first, found no
       input to write to, and returned -- leaving the model list empty and
       disabled forever. Alex found it live, 2026-08-04: "I cannot select a
       kayak model, when I click nothing drops down". */
    if (t.classList && t.classList.contains('ls-boat-mfr')) {
      var bbox = t.closest ? t.closest('.ls-fit') : null;
      var bwrap = bbox && bbox.closest
        ? bbox.closest('.block-size-recommender') : null;
      var burl = bwrap ? bwrap.getAttribute('data-ls-boats') : null;
      var bdata = burl ? boatData[burl] : null;
      var mEl = bbox ? bbox.querySelector('.ls-boat-model') : null;
      if (bdata && mEl) {
        fillSelect(mEl, t.value ? sortedKeys(bdata.tree[t.value] || {}) : [],
                   'Select your model');
        /* The model search box belongs to whichever brand is chosen. Leaving
           the previous text in it would show a filtered slice of a list the
           customer has never seen, and the emptiest possible result -- "No
           match" against a brand they just picked -- reads as a broken page. */
        var mFind = mEl.parentNode
          ? mEl.parentNode.querySelector('.ls-boat-find') : null;
        if (mFind) {
          mFind.value = '';
          mFind.disabled = !t.value;
          hideList(mFind);
          mFind.setAttribute('placeholder', t.value
            ? 'Type to search models' : 'Choose a brand first');
        }
      }
      return;
    }

    /* The select is the visible control; the input is what report() reads. */
    if (t.classList && t.classList.contains('ls-pdp-sel')) {
      var inp = t.parentNode
        ? t.parentNode.querySelector('input[data-ls-f]') : null;
      if (inp) { inp.value = t.value; }
      return;
    }

    /* Unit toggle -- rebuild the dropdowns of every recommender that radio
       governs, not just the one it happens to sit inside. Applies on the chart
       pages too, since the dropdowns now ship everywhere. */
    if (String(t.className || '').indexOf('ls-r') !== -1) {
      unitSelects(t);
    }
  });

  function init() {
    prefill(); enable(); pdpIntro(); pdpHowTo(); allSelects();
    var boxes = document.querySelectorAll('.block-size-recommender .ls-fit'), i;
    for (i = 0; i < boxes.length; i++) { boatInit(boxes[i]); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  setTimeout(init, 1200);
})();

/* PHONE SIZING. Alex, 2026-07-31, with the old JPEG chart alongside for
   comparison: everything -- how to measure, the diagram, the table and the size
   selector -- visible within about two scrolls, with almost no sideways
   scrolling, and DESKTOP UNTOUCHED.

   An earlier pass folded the instructions and the recommender into <details>.
   That reached the scroll budget by hiding two of the four things he listed, so
   it answered the wrong question and has been removed. The budget is met by
   compaction instead: roughly 20% off the type, padding in em so it shrinks
   with it, and the table sized to its own column count below.

   THE ONE THING THE STYLESHEET CANNOT WORK OUT ALONE is how many columns a
   table has, and that is what decides whether it fits. A five-column chart has
   room for readable type; Mariner's thirteen do not. So the count goes onto the
   table as a custom property and the CSS scales the type from it -- which is
   how the old JPEG fitted a seven-column chart on one screen, just done with
   text that a screen reader and Google can still read.

   NOTHING IS MOVED. The arrangement is done with grid-template-areas over four
   flat siblings the generator emits, so there is no DOM surgery to fight the
   size modal's cascade and nothing to undo when the viewport crosses back over
   600px. This block sets one custom property and stops. */
(function () {
  var PHONE = '(max-width: 600px)';
  var DONE = 'data-ls-cols-set';

  function isPhone() {
    try { return !!(window.matchMedia && window.matchMedia(PHONE).matches); }
    catch (e) { return false; }
  }

  function apply(root) {
    if (root.getAttribute(DONE) === '1') return;  /* idempotent: init runs again
                                                     at 1.2s for blocks the size
                                                     modal clones in late, and
                                                     again on resize. */
    var tables = root.querySelectorAll('table.ls-table');
    if (!tables.length) return;
    root.setAttribute(DONE, '1');
    /* Collapse the instructions. The markup ships OPEN so that a phone with no
       script still shows everything -- long, but complete -- and this closes it
       where a script is running. An attribute, not a node move: nothing to
       fight the size modal's cascade, and reopening is one line. */
    var fold = root.querySelector('details.ls-measure-block');
    if (fold) { fold.open = false; }
    for (var i = 0; i < tables.length; i++) {
      /* Header cells, so a two-table skirt chart sizes each table to its own
         width rather than both to the wider one. */
      var cols = tables[i].querySelectorAll('thead th').length;
      if (cols) { tables[i].style.setProperty('--ls-cols', cols); }
    }
  }


  function reopen(root) {
    /* Above the breakpoint the disclosure is a heading again, so it must be
       open: a desktop window narrowed and widened again would otherwise keep
       the instructions collapsed, which is a changed desktop layout. */
    var fold = root.querySelector('details.ls-measure-block');
    if (fold) { fold.open = true; }
    root.removeAttribute(DONE);
  }

  function init() {
    var phone = isPhone();
    var blocks = document.querySelectorAll('.ls-sizechart');
    for (var i = 0; i < blocks.length; i++) {
      if (phone) { apply(blocks[i]); } else { reopen(blocks[i]); }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  setTimeout(init, 1200);
  window.addEventListener('resize', init);
})();

/* Fallback ONLY for browsers without :has(). Modern browsers exit immediately
   and the toggle stays pure CSS. Listener is delegated on document, so it also
   drives copies the product-page size modal clones at runtime -- a listener
   bound to these nodes directly would not survive cloning. */
(function () {
  try {
    if (window.CSS && CSS.supports && CSS.supports('selector(:has(*))')) return;
  } catch (e) { /* CSS.supports missing: fall through and enhance */ }
  var SEL = '.ls-sizechart';
  function sync(root) {
    /* `:checked` INSIDE the selector, for the same reason unitOf() needs it: the
       two toggles share a radio NAME, so the first `.ls-r-in` is the one the
       browser unchecks whenever the customer uses the second toggle. The
       two-step form here made the fallback ignore the recommender's own toggle
       -- the display equivalent of the wrong-unit bug fixed in report(). */
    root.classList.toggle('ls-show-in', !!root.querySelector('.ls-r-in:checked'));
  }
  function init() {
    var blocks = document.querySelectorAll(SEL);
    for (var i = 0; i < blocks.length; i++) {
      blocks[i].classList.add('ls-js');
      sync(blocks[i]);
    }
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.className || String(t.className).indexOf('ls-r') === -1) return;
    var root = t.closest ? t.closest(SEL) : null;
    if (root) sync(root);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  setTimeout(init, 1200);
})();
